import type { Theme } from '@emotion/react';

export const buildAccountWidgets = (vars: Omit<Theme, 'widgets'>) => ({
  WinePlanCarousel: {
    controls: `
        width: 100%;
        margin-bottom: 10px;
        top: 90px;
           ${vars.breakpoints.sm} {
              top: calc(50% - 3rem);
           }
          ${vars.breakpoints.lg} {
            .flex-products & {
              left: -30px; // -30px shifts controls left; +60px widens to cover extra space on both sides.
              width: calc(100% + 60px); // Extend controls beyond the carousel container to visually align with the product grid.
            }
          }
      `,
    control: `
        height: 36px;
        width: 36px;
      `,
    viewport: `
        padding-bottom: 24px;
      `,
    indicators: `
        bottom: 5px;
      `,
    indicator: `
        border-radius: 50%;
        width: 12px;
        height: 12px;
        background: #BCBCBC;
        opacity: 1;
        &[data-active] {
          background: ${vars.colors.grey50};
        }
      `,
  },
  Membership: {
    wrapper: `
        & .accordion-navigation{
          width:200px;
          span {
            padding: 0;
          }
        & .accordion-panel {
          background-color: #FCFBF9;
          margin-top: 10px;
          padding: 10px 2px 2px 20px;
        }
        & .mantine-Accordion-item{
            width: 100%;
            border:none;
            margin-bottom: 10px;
            font-size:14px;
            color: #333333;
            margin-left: 4px;
            margin-top: 4px;
            margin-bottom: 10px;
            text-wrap: nowrap;
            gap: 10px;
          & button{
            padding: 0;
            display: flex;
            justify-content: space-between;
            width: 100%;
          }
        }
      }
      margin-left: 0;
      margin-right: 0;
      background: ${vars.colors.white};
      display:flex;
        .membership-layout {
          width:100%;
          padding: 10px;
          margin-left:0px;
          ${vars.breakpoints.xs} {
            padding:20px;
          }

        .error-message{
          padding: 0 25px 15px 0;
        }
        .init-loader{
          display:flex;
          margin-left: 45%;
          margin-top: 20%;
        }
        .loader{
          position: fixed;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          &.full-page-loader{
            background-color: rgb(0 0 0 / 36%);
          }
        }
        .card-container {
          display:flex;
          gap: 24px;
          flex-wrap: wrap;
          flex-direction: row;


          .cancel-membership {
            width: 100%;
            display:flex;
            font-size:14px;
            font-weight: ${vars.fonts.weightNormal};
            margin-bottom:0;
            align-items:center;
            .cancel-membership-checkbox{
              appearance: none;

              width: 19px;
              height: 19px;
              box-shadow: none;
              border-radius: 4px;
              border: 1px solid;
              color: ${vars.colors.black};

              margin-right:10px;
              cursor:pointer;
              &:checked{
                background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Checkbox'%3E%3Crect width='18' height='18' fill='var(--checkbox-bg-color, ${vars.colors.svgCheckboxBg})'/%3E%3Cpath id='Vector' d='M14 5L7.125 12L4 8.81818' stroke='var(--checkbox-stroke-color, ${vars.colors.svgCheckboxStroke})' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E%0A");
                color: transparent;
              }
              &.disable{
                pointer-events: none;
                cursor: not-allowed;
              }
            }
            .cancel-membership-text{
              width:100%;
            }
          }

          .update-visible {
            display: block;
          }

          .update-hidden {
            display: none;
          }
          

          .membership-card {
            width:420px;
            height:260px;
            background:white;
            padding:24px;
            display:flex;
            flex-direction:column;
            border: 1px solid ${vars.colors.secondary9};
            border-radius: 4px;
            h2{
                  margin-top: 0;
                }
            h3{
              font-family: ${vars.fonts.familySecondary};
              text-transform: none;
            }
            .card-heading{
              font-size: 22px;
              ${vars.breakpoints.lg} {
                font-size:28px;
              }
              font-family: ${vars.fonts.familyTertiary};
              font-weight: ${vars.fonts.weightNormal};

            }

            .cancel-save-offer-cta {
              text-decoration:underline;
              margin: auto;
            }

            .card-details{
              display:flex;
              align-items:center;
              .card-details-number{
                padding-left:10px;
              }

            }
            .membership-status{
            font-size:40px;
            font-family: ${vars.fonts.familyPrimary};
            color:${vars.colors.primary1};
            text-transform:uppercase;
            line-height: 52px;
            margin:auto;

            }
            .change-payment-card{
              display:flex;
              font-size:16px;
              font-weight: ${vars.fonts.weightNormal};
              margin:auto;
              margin-bottom:0;
              align-items:center;

            }
            .cancel-membership.disable{
              cursor: not-allowed;
            }

            .enroll-data{
              display:grid;
              grid-template-columns: 0.7fr 1fr;

              h3{
                font-family: ${vars.fonts.familySecondary};
                font-weight:${vars.fonts.weightNormal};
                font-size:16px;
                line-height: 24px;
              }
              .date{
                font-weight: ${vars.fonts.weightBold};
                padding-left: 10px;
              }
            }

            .last-payment-row{
              display:grid;
              grid-template-columns: 0.7fr 1fr;

              h3{
                font-family: ${vars.fonts.familySecondary};
                font-weight:${vars.fonts.weightNormal};
                font-size:16px;
                line-height: 24px;
              }
              .payment-date{
              font-size:16px;
              font-weight:${vars.fonts.weightBold};
              padding-left: 10px;
              .loaderContainer{
                justify-content: start;
                div{
                  width: 21px;
                  height: 21px;
                }
              }
              }
            }

          }
          .saving{
            font-family: ${vars.fonts.familyTertiary};
            align-items:center;
            text-align: center;
            .saving-price{
              padding:20px;
              display: grid;


            .card-heading{
              margin:0;
              font-family: ${vars.fonts.familyPrimary};
              font-weight: ${vars.fonts.weightNormal};
              font-size: 50px;
              ${vars.breakpoints.md} {
                font-size: 44px;
                }
              ${vars.breakpoints.lg} {
              font-size: 60px;
              }
              color:${vars.colors.primary1};
              }
              .year-note{
                font-size: 18px;
                font-family: ${vars.fonts.familyTertiary};
              }
              color: ${vars.colors.grey60};
            }
            .static-data{
              font-family: ${vars.fonts.familyTertiary};

              font-weight: ${vars.fonts.weightMedium};
              font-size: 18px;
              color: ${vars.colors.grey60};
              padding: 20px 0px;
            }
            .static-note{
              display: grid;
              font-family: ${vars.fonts.familySecondary};
              font-weight: ${vars.fonts.weightNormal};
              font-size: ${vars.fonts.sizeLarge};
              color: ${vars.colors.black};
              margin: auto;
              margin-bottom: 20px;
              font-weight: ${vars.fonts.weightNormal};
              font-size: ${vars.fonts.sizeLarge};
              line-height: 22.4px;
            }
          }
          .faq-card{
            width:100%;
            ${vars.breakpoints.xl} {
              width:854px;
            }
            height:auto;
            display:flex;
            flex-direction: row;
            .left-faq{
              width: 40%;
              .view-all-faq{
                font-size:16px;
                margin-top: 10%;
                ${vars.breakpoints.xs} {
                  padding:2px 5px;
                  font-size:14px;
                }
                ${vars.breakpoints.sm} {
                  padding:10px;
                }
                ${vars.breakpoints.md} {
                  padding: 7.5px 22px;
                }

              }
            }
          .right-faq{
            width: 60%;
          }
            .faq-question{
              margin-bottom:24px;
              text-decoration:underline;
              display:block;
              font-weight: ${vars.fonts.weightNormal};
              line-height:22px;
              font-size: ${vars.fonts.sizeLarge};
            &.active{
              font-weight: ${vars.fonts.weightBold};
            }
            }
            .faq-question-right.heading{
              margin-top:12%;
              margin-bottom:24px;
              font-weight: ${vars.fonts.weightBold};
            }
            .vertical-line {
              width: 1px;
              background-color: ${vars.colors.grey20}; /* Adjust the color as needed */
              margin: 5% 16px 10% 16px;
            }

          }
          // footer banner
        .footer-banner{
          width: 100%;
          & div{
            margin:0;
          }
          & .description{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          & .banner-button{
            bottom: 0;
            margin-bottom: 18px;
            position:absolute;
          }
        }
        }
      }
      .bread-crumb-list{
        display:flex;
        & a{
          font-size:11px;
          ${vars.breakpoints.sm} {
            font-size:16px;
          }
        }
        .slash{
          padding:12px;
        }
      }
      .title-icon{
        display:flex;
        justify-content:center;
      }
      .hub-page-no-plan{
        width:80%;
        h1{
          margin-left:10px;
        }
        h1{
          font-size: 40px;
        }
        .no-plan-message{
          background:${vars.colors.specialLight};;
          padding: 10px;
          margin:10px;
        }
    }
      `,
    Sidebar: `
      background:white;
      padding-left: 5%;
      display:none;
      ${vars.breakpoints.md} {
       display:flex;
       }
        .membership-sidebar{
          background: white;
          padding-left:40px;
          height:100%;

          & div{
            margin:0;
            padding:0;
          }

          & .navigation-link{
            ${vars.breakpoints.xs} {
                  width:260px;
            }
            > h4{
              font-size:28px;
              font-family: ${vars.fonts.familyTertiary};
                // margin-bottom: 24px;
                color:${vars.colors.primary1};
                margin-bottom: ${vars.space.lg};
                margin-top: ${vars.space.lg};
            }
            & a{
              font-size:18px;
              margin-bottom:18px;
              line-height:24px;
            }
          }
      }`,
    pageWrapper: `
        & .intro-text{
          ${vars.mixins.h5}
          font-size: ${vars.fonts.sizeLarger};
          text-align: center;
          margin-top: 16px;
          margin-bottom: 16px;
          line-height: 200%;
          ${vars.breakpoints.sm} {
            font-size: ${vars.fonts.sizeLarger};
          }
        }
        .top-section .widget-container > div {
          margin: 0;
        }
        .bottom-section{
          .widget-cms-column > div{
            margin: 0;
          }  
          .widget-cms-column{
            .banner-wrapper {
             height: 100%;
            }
            .banner {
              margin: 0;
              ${vars.breakpoints.md} {
                overflow: hidden;
              }     
              p span {
                font-size: 16px;
              }
              h3 span {            
                line-height: 29.4px;
                ${vars.breakpoints.md} {
                  line-height: 33px;
                } 
              }
              .banner-image-wrapper {
                order: 1;
                ${vars.breakpoints.md} {          
                  align-self: center;
                  order: 2;
                }
                ${vars.breakpoints.lg} {
                  max-height: 250px;
                }
              }
              .banner-content-wrapper {
                order: 2;
                ${vars.breakpoints.md} {
                  order: 1;
                }
              }
              .banner-bg-img {
                height: 115px;
                ${vars.breakpoints.sm} {
                  height: 250px;
                }
                ${vars.breakpoints.lg} {
                  height: 100%;
                }
              }
              .banner-button {
                padding: 0;
              }
              .banner-button a{
                padding: 7px 16px;
                min-width: 180px;
                font-weight: ${vars.fonts.weightMediumPlus};
                font-size: 12px;
                line-height: 14px;
                &:active, &:focus {
                  text-decoration: none;
                }
              }
              .cms-image-container {
                width: 100%;
                height: 100%;
                img {      
                 height: 100%;
                 object-fit: cover;
                }
              }
            }
            & .banner-info {
              ${vars.breakpoints.md} {
                 padding: 24px;
              }
              width: 100%;
              padding: 16px;
            }
            .banner-content {
              text-align: center;
              padding: 0;
              ${vars.breakpoints.sm} {
                text-align: initial;
                padding: initial;
              }
            }
          }     
          
        }
        .payment-method {
          .mantine-Accordion-item::after {
              content: "";
              left: -16px;
              right: -16px;
              height: 1px;
              background-color: ${vars.colors.secondary9};
              position: absolute;
              ${vars.breakpoints.sm} {
                left: 0px;
                right: 0px;
              }
          }     
        }
      `,
  },
  MembershipRebranding: {
    container: `
        & .no-plan-message{
          margin:40px 0;
          & p {
            font-family: ${vars.fonts.roboto};
            font-weight: ${vars.fonts.weightBold};
          }
        }

        .loader{
          position: fixed;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          &.full-page-loader{
            background-color: rgb(0 0 0 / 36%);
          }
        }
      `,
    layout: `
        margin-top: 24px;
        ${vars.breakpoints.sm} {            
          margin-top: 40px;
        }
        & .membership-details{
          display: grid;
          grid-template-columns: 1fr;
          justify-content: center;
          gap: 16px;
          & > div{
            flex: 1;
          }
          ${vars.breakpoints.sm} {
            grid-template-columns: 1fr 1fr;
            gap: 24px;
          }
        }

        
        & .renew-layout {
            margin-bottom: 24px;
            ${vars.breakpoints.sm} {            
              margin-bottom: 40px;
            }
            .cancel-membership {
            width: 100%;
            display:flex;
            font-size:14px;
            font-weight: ${vars.fonts.weightNormal};
            margin-bottom:0;
            gap: 16px;
            align-items: flex-start;
            ${vars.breakpoints.sm} {                       
              align-items:center;
            }
            .cancel-membership-checkbox{
              appearance: none;
              width: 19px;
              height: 19px;
              box-shadow: none;
              border-radius: 4px;
              border: 1px solid;
              color: ${vars.colors.black};
              margin-right:10px;
              cursor:pointer;
              &:checked{
                background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Checkbox'%3E%3Crect width='18' height='18' fill='var(--checkbox-bg-color, ${vars.colors.svgCheckboxBg})'/%3E%3Cpath id='Vector' d='M14 5L7.125 12L4 8.81818' stroke='var(--checkbox-stroke-color, ${vars.colors.svgCheckboxStroke})' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E%0A");
                color: transparent;
              }
              &.disable{
                pointer-events: none;
                cursor: not-allowed;
              }
            }
            .cancel-membership-text{
              width:100%;
              font-family: ${vars.fonts.roboto};
              font-weight: ${vars.fonts.weightNormal};
              font-size: ${vars.fonts.sizeH4};
              color: ${vars.colors.primary8};
            }
          }
          .update-visible {
            display: block;

            button.unlimited-modal-primary-cta {
              cursor: pointer;
              width: 100%;
              background-color: #117B53;
              color: ${vars.colors.btnsPrimaryColor};
              ${vars.breakpoints.sm} {
                width: auto;
              }

              :hover {
                background-color: #094B32;
                color: ${vars.colors.btnsPrimaryColor};
              }
              }
            }

          .update-hidden {
            display: none;
          }
        }
      `,
    membershipOffers: `
        border: 1px solid ${vars.colors.secondary15};
        padding-left: 24px;
        display: grid;
        grid-template-columns: 0.75fr 1fr;
        gap: 8px;
        .membership-offers {
          padding: 24px 0;
        }
        .membership-offers-subtitle {
          color: ${vars.colors.textUnlimitedBg};
          margin: 14px 0;
        }
        .offers-message {
          ${vars.mixins.body1};
          font-weight: ${vars.fonts.weightBold};
          margin-bottom: 14px;
          max-width: 75%;
        }
        button.shop-now-button {        
          cursor: pointer;
          padding: 7px 16px;
          min-width: 150px;
          font-weight: ${vars.fonts.weightMediumPlus};
          text-transform: uppercase;
          font-size: 12px;
          line-height: 14px;
        }
        .membership-image {
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          ${vars.breakpoints.lg} {            
            clip-path: polygon(0% 20%, 30% 0%, 100% 0%, 100% 60%, 60% 90%, 0% 75%);
          }
        }
      `,
    membershipStatus: `
        border: 1px solid ${vars.colors.secondary15};
        padding: 24px;
        h1.membership-status {
          font-family: ${vars.fonts.oswald};
          font-weight: ${vars.fonts.weightMedium};
          color: ${vars.colors.textUnlimitedBg};
        }
        .year-note {
          font-family: ${vars.fonts.oswald};
          font-weight: ${vars.fonts.weightMedium};
          font-size: ${vars.fonts.sizeLarge};
          padding-left: 8px;
          color: ${vars.colors.textUnlimitedBg};
          position: relative;
          top: -3px;
        }
        .saving-instruction {
          font-family: ${vars.fonts.roboto};
          padding-top: 8px;
          font-weight: ${vars.fonts.weightNormal};
          font-size: ${vars.fonts.sizeLarge};
        }
        .saving-note {
          font-family: ${vars.fonts.roboto};
          font-weight: ${vars.fonts.weightNormal};
          font-size: ${vars.fonts.sizeH5};
          color: ${vars.colors.secondary15};
          margin-top: 12px;
        }
        .price-section {
          display: flex;
          align-items: baseline;
        }
        .membership-status-title {
          font-family: ${vars.fonts.noto};
          font-weight: ${vars.fonts.weightMediumPlus};
          .savings-title {
            text-transform: capitalize;
          }
        }
        .membership-subscription-title {
          font-family: ${vars.fonts.roboto};
          font-weight: 700;
          font-size: ${vars.fonts.sizeLarge};
          padding-top: 10px;
        }
        .enroll-info {
          margin-top: 12px;
          font-family: ${vars.fonts.roboto};
          font-weight: ${vars.fonts.weightBold};
          font-size: ${vars.fonts.sizeLarge};
          & .date {
            font-weight: ${vars.fonts.weightNormal};
            font-size: ${vars.fonts.sizeLarge};
            padding-right: 8px;
          }
        }
      `,
    payment: `
        margin-top: 24px;
        ${vars.breakpoints.sm} {            
          margin-top: 40px;
        }
        .payment-title{
          font-family: ${vars.fonts.noto};
          font-weight: ${vars.fonts.weightMediumPlus};
        }
        .last-payment-row{
          display: flex;
          font-family: ${vars.fonts.roboto};
          font-size: ${vars.fonts.sizeLarge};
          color:${vars.colors.primary8};
          gap: 4px;
        }
        .last-payment-title{
          font-weight: ${vars.fonts.weightNormal};
          padding-right: 4px;
        }
        .payment-date{
          font-weight: ${vars.fonts.weightBold};
          .loaderContainer div {
            width: 20px;
            height: 20px;
            border-width: 2px;
          }
        }
      `,
    paymentMethod: `
        margin: 24px 0;
        .single-frequency-text {
          font-family: ${vars.fonts.roboto};
          font-size: ${vars.fonts.sizeH4};
        }
        .accordion-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .card-details {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .card-number {
          ${vars.mixins.body1}
          color:${vars.colors.primary8};
        }
        .change-payment-card a {
          font-weight: ${vars.fonts.weightMediumPlus};
          font-size: ${vars.fonts.sizeH5};
          color:${vars.colors.primary8};
          word-break: normal;
        }
        .subscription-option-accordion {
          .mantine-Accordion-item {
            border-bottom: none;
          }
        }
      `,
  },
  MyAccount: {
    deliveryStepperWrapper: `
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        width: 100%;

        .stepper-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;

          @media (max-width: 768px) {
            font-size: 12px;
          }

          &::before {
            position: absolute;
            content: "";
            border-bottom: 1px solid #BCBCBC;
            width: 100%;
            top: 8px;
            left: -50%;
            z-index: 2;
          }

          &::after {
            position: absolute;
            content: "";
            border-bottom: 1px solid #BCBCBC;
            width: 100%;
            top: 8px;
            left: 50%;
            z-index: 2;
          }

          .step-counter {
            position: relative;
            z-index: 5;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #ffffff;
            border: 1px solid ${vars.colors.secondary15};
            margin-bottom: 6px;
          }

          &.active {
            color: #006E1A;

            .step-counter {
              background: #ffffff;
              border: 1px solid #006E1A;

              .step-counter-inner {
                background: #006E1A;
                width: 12px;
                height: 12px;
                border-radius: 50%;
              }
            }


          }

          &:first-of-type::before {
            content: none;
          }

          &:last-child::after {
            content: none;
          }
        }
      `,
    yourFutureDelivery: `
        margin: 50px auto 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;

        .delivery-heading {
          width: fit-content;
          font-size: 24px;
          margin: auto;
          ${vars.breakpoints.sm} {
            font-size:34px;
          }
          
          font-family: ${vars.fonts.familyPrimary};
        }

        .delivery-text {
          font-size: 12px;
          font-family: ${vars.fonts.familySecondary};
          margin:auto;

          ${vars.breakpoints.sm} {
            font-size:16px;
          }
        }

        .change-delivery-notification {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          background-color: #f8f5ec;
          padding: 12px;
          border-radius: 6px;
          width: 100%;
          margin-top: 24px;

          .left {
            display: flex;
            align-items: center;

            .notification-text {
              font-size: 12px;
              margin-left: 8px;

              ${vars.breakpoints.sm} {
                font-size:16px;
              }
            }
          }

          .notification-action {
            background: none;
            border: none;
            text-decoration: underline;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;
            ${vars.breakpoints.sm} {
              font-size:16px;
            }
          }
        }

        .packing {
          background-color: #B3CFE5;
        }
        .inDelivery {
          background-color: #B3CFE5;
        }
      `,
    wrapper: `
        display: grid;
        ${vars.breakpoints.md} {
          grid-template-columns:380px 1fr;
        }
      `,
    sideBar: `
      display:none;
      ${vars.breakpoints.md} {
        display:grid;
      }
      padding: 50px 10px 30px 45px;
        & div{
          margin:0;
          padding:0;
        }
        & .navigation-link{
          ${vars.breakpoints.xs} {
              width:260px;
          }
          a{
            font-size: ${vars.fonts.sizeLarge};
            margin-bottom: 18px;
            font-family: ${vars.fonts.familySecondary};
            line-height: 22.4px;
            color: ${vars.colors.grey50};

          }
          h4{
            font-size:30px;
            color:${vars.colors.primary1};
            font-family: ${vars.fonts.familyTertiary};
            margin: 20px 0px;
          }
        }
        & .myaccount-sidebar{
          padding:10px;

        }
      `,
    winePlan: `
        display: grid;

        .error-message {
          margin-top:16px;
          padding:18px;
          background-color:${vars.colors.errorLight};
          color:${vars.colors.error};
        }
    
        .delay-delivery-button {
          display: flex;
          gap: 8px;
          align-items: center;
          margin-bottom: 30px;
          button.cancel-tertiary-cta {
            margin: 0;
          }
        }

        button.cancel-tertiary-cta {
          cursor: pointer;
          padding: 0px;
          text-decoration: underline;
          text-underline-offset: 4px;
          border:none;
          font-weight: ${vars.fonts.weightNormal};
          font-size: ${vars.fonts.sizeDefault};
          text-align: left;
          background-color: transparent;
          color: ${vars.colors.black};
          &:hover {
            text-decoration: underline;
            color: ${vars.colors.black};
            background-color: transparent;
            border: none;
          }
          width: fit-content;
          margin-bottom: 20px;
          ${vars.breakpoints.sm} {
            width: fit-content;
            margin-bottom: 30px;
          }
        }

          .spinner {
            min-height: 50px;
            position: relative;
            margin-top: 50px;
          }
          .payment-method {
              margin: 0;
              &:last-of-type{
                margin-bottom: 40px;
                .mantine-Accordion-item::after {
                  content: "";
                  left: -16px;
                  right: -16px;
                  height: 1px;
                  background-color: ${vars.colors.secondary9};
                  position: absolute;
                  ${vars.breakpoints.sm} {
                    left: 0px;
                    right: 0px;
                  }
                }
              }
          }
          .subscription-option{         
            h6{
              font-size:26px;
            }
            .loadIcon {
              margin: 10px 0;
            }
          }
          .case-details{
            display: grid;
            margin-top:${vars.space.xl2};
            gap:${vars.space.xl};
            ${vars.breakpoints.xs} {
              grid-template-columns: 1fr;
            }
            ${vars.breakpoints.sm} {
            grid-template-columns:0.8fr 1fr;
            }

              .case-image{
                display: grid;
                justify-content:end;
                position:relative;
                width:90px;
                height:82px;
                justify-self: flex-end;
                @media (min-width: 360px) {
                  display:none;
                }
                ${vars.breakpoints.sm} {
                  display: grid;
                  width:164px;
                  height:146px;
                }
                ${vars.breakpoints.md} {
                  display: grid;
                  width:146px;
                  height:130px;
                }
                ${vars.breakpoints.lg} {
                  display: grid;
                  width:174px;
                  height:156px;
                }
                ${vars.breakpoints.xl} {
                  display: grid;
                  width:190px;
                  height:170px;
                }
                ${vars.breakpoints.xxl} {
                  display: grid;
                  width:260px;
                  height:233px;
                }
              }
              .personalized-section {
                    margin: 8px 0 0;
                    ${vars.mixins.body3}
                    font-weight: ${vars.fonts.weightMediumPlus};
                    color:#006E1A;
                    background:  ${vars.colors.secondary16};
                    padding: 4px 12px;
                    border-radius: 12px;
              }
              .case-info{
              display: flex;
              flex-direction: column;
              padding-top: 1.15rem;
              align-items: start;
                .scheme-name{
                  font-size:24px;
                  font-weight: ${vars.fonts.weightMediumPlus};
                  ${vars.breakpoints.sm} {
                    font-size:30px;

                    }
                  ${vars.breakpoints.xxl} {
                    font-size:34px;
                    text-transform: uppercase;
                  }


                  font-family: ${vars.fonts.familyPrimary};
                  line-height: 35.7px;


                }
                .case-price-info{
                  font-size: 18px;
                  font-weight: ${vars.fonts.weightBold};
                  ${vars.breakpoints.sm} {
                    font-size: 22px;
                    font-weight: ${vars.fonts.weightMediumPlus};
                  }

                  display:flex;
                  flex-direction: column;
                  ${vars.breakpoints.sm} {
                  align-items:center;
                  flex-direction: row;
                  margin-top:${vars.space.xs};
                  }
                  padding:10px 0px;
                  .case-price{
                  line-height: 26.4px;
                  }
                  .case-saving-price{
                    margin-top:${vars.space.xs};
                    ${vars.breakpoints.sm} {
                      margin-top:0;
                      margin-left:${vars.space.xs};
                      }

                    color: ${vars.colors.primary1};
                    background: ${vars.colors.primary5};
                    border-radius:16px;
                    padding:4px 10px;
                    width: fit-content;
                    font-size: 12px;

                  }
                    .case-discount-price{
                    margin-top:${vars.space.xs};
                    ${vars.breakpoints.sm} {
                      margin-top:0;
                      margin-left:${vars.space.xs};
                      }

                    color: ${vars.colors.secondary6};
                    background:  ${vars.colors.secondary16};
                    border-radius:16px;
                    padding:8px;
                    width: fit-content;
                    font-size: 12px;

                  }
                }
                .case-standard-price{
                  color: ${vars.colors.grey60};
                  padding-bottom:13px;
                  font-size: 16px;

                }
                .case-bottle-count{
                  font-size: 16px;
                  color: ${vars.colors.grey50};
                  font-weight: ${vars.fonts.weightNormal};

                }
                .case-swap-links {
                  display: flex;
                  margin-top: 8px;
                  gap: 4px;
                  flex-direction: column;
                  ${vars.breakpoints.xs} {
                    width: 100%;
                  }
                  ${vars.breakpoints.sm} {
                    flex-direction: row;
                    width: fit-content;
                  }
                  ${vars.breakpoints.md} {
                    width: fit-content;
                  }
                  ${vars.breakpoints.xl} {
                    width: fit-content;
                  }
                  ${vars.breakpoints.xxl} {
                    width: fit-content;
                  }
                }
                .case-not-select-container{
                  display: flex;
              flex-direction: column;
              align-items: start;
              .coming-soon-heading {
                color: ${vars.colors.grey50};
                margin: 0;
                padding:13px 0px;
              }
              .case-not-select-notes{
                font-size: ${vars.fonts.sizeH4};

              }
              .take-case{
                width:190px;
                margin:13px 0px;
                font-size: 14px;
                font-weight: ${vars.fonts.weightMediumPlus};
                border-radius: 4px;
              }
                }
              }

          }
          .bottles-details-wrapper{
          display:grid;
          margin-top: ${vars.space.xl};
            .header{
              font-size: 18px;
              font-weight: ${vars.fonts.weightMediumPlus};
              font-family: ${vars.fonts.familyTertiary};

            }
          .case-update {
            ${vars.mixins.body2}
            margin-top: 12px;
            display: flex;
            gap: 8px;
            align-items: center;
            color:#006E1A;
            & i {
              font-size: 18px;
            }
          }
          .product-row{
            display:flex;
            align-items: center;
            .arrow-slide {
              background:white;
              border-radius:15px;
              cursor: pointer;
              ${vars.breakpoints.xs} {
              position: absolute;
              z-index: 1;
              &.right{
                right:25px;
                }
              }
              ${vars.breakpoints.sm}{
                position: relative;
                &.right{
                margin:auto;
                margin-right: 0px;
                }
              }
            }

            .bottles-details {

              display: grid;

              .bottle-container {
                display: grid;
                grid-auto-flow: column; /* Arrange items in a single row */
                grid-auto-columns: minmax(293.33px, 1fr); /* Define minimum and maximum column sizes */
                overflow-x: auto; /* Enable horizontal scrolling */
                white-space: nowrap; /* Prevent line breaks */
                gap: 10px; /*space between grid items */
                padding: 20px;
                scrollbar-width: none;


                  .product-card {
                    display: flex;
                    position: relative;
                    flex-direction: column;
                    align-items: center;
                    padding: 15px;
                    white-space: normal;
                    height:100%;
                      &.gift-card{
                        border: 1px solid ${vars.colors.secondary9};
                        border-radius: 4px;
                        background: none;
                          & .gift-tag{
                            justify-content: start;
                            position: absolute;
                            display:flex;
                            gap:7px;
                            background-color: ${vars.colors.grey00};
                            padding:10px;
                            border-radius: 4px;
                            font-weight:700;
                            font-size:16px;
                            z-index:1;
                          }
                        }
                    & .product-details-parent{
                       height:auto;
                       ${vars.breakpoints.sm}{
                         height:100%;
                       }
                    }
                    .product-details{
                      margin: auto;
                      margin-bottom: 0;
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      height:100%;
                      ${vars.breakpoints.sm} {
                         align-items: start;
                      }
                      .product-name{
                      font-size: 18px;
                      font-weight: ${vars.fonts.weightMediumPlus};
                      margin: 18px 0 15px 0;
                      font-family: ${vars.fonts.familyTertiary};
                      margin-top: 10px;
                      &.single-line{
                        max-height: 4em;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        //margin-top: -8.1px;
                      }
                      }
                      .product-count{
                        color: ${vars.colors.grey60};
                        font-size: 16px;
                        font-weight: ${vars.fonts.weightNormal};
                        padding-bottom: 15px;
                        align-items: center;
                        display: flex;
                        margin-top:auto;
                      }
                    
                      .product-label,.mobile-product-label{
                        display:none;
                        ${vars.breakpoints.sm} {
                          display:block;
                          cursor:pointer;
                          }
                        background:none;
                        border:none;
                        color: ${vars.colors.grey50};
                        font-size: 16px;
                        font-weight: ${vars.fonts.weightNormal};
                        padding-top: 10px;
                        padding-bottom: 2px;
                        width: fit-content;
                        box-shadow: inset 0 -1px 0 0 black;
                        cursor:pointer;

                      }
                       .mobile-product-label{
                         display:block;
                        ${vars.breakpoints.sm} {
                          display:none;
                          cursor:pointer;
                          }
                      }
                      &.non-wine-gift{
                        .product-label,.product-count,.wine-rating{
                          visibility: hidden;
                        }

                      }
                    }
                    .product-name{
                        font-size: 18px;
                        font-weight: ${vars.fonts.weightMediumPlus};
                        font-family: ${vars.fonts.familyTertiary};
                        padding: 16px;
                    }
                    .image-container {
                      display: flex;
                      justify-content: center;
                    
                      .image-size {
                        position: relative;
                        width: 48px;
                        height: 180px;
                      
                        ${vars.breakpoints.lg} {
                          width: 120px;
                          height: 220px;
                        }
                    }
                }
              }
            }
          }
          }
      `,
    winePlanProductImage: `
          width: 100%;
          .product-image-container {
          padding: 16px 0;
          margin-bottom: 13px;
          background-color: ${(vars.colors.bgColors as unknown as { [key: string]: string }).LWCream}; 
          .label-card {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            background: white;
            color: black;
            padding: 10px;
            box-sizing: border-box;
            z-index: 1;
            height: 200px;
            flex-direction: column;
            justify-content: center;
            align-items: start;
          
            ${vars.breakpoints.lg} {
              height: 240px;
            }
          
            .label-row {
              margin-left: 20%;
            
              i {
                padding: 5px;
              }
            
              display: grid;
              grid-template-columns: auto 1fr;
              align-items: center;
              padding:8px;
            }
          }
        
          &:hover .label-card {
            display: flex;
          }
        
          .image-container {
            display: flex;
            justify-content: center;
            background-color: ${(vars.colors.bgColors as unknown as { [key: string]: string }).LWCream};
          
            .image-size {
              position: relative;
              width: 48px;
              height: 180px;
            
              ${vars.breakpoints.lg} {
                width: 120px;
                height: 220px;
              }
            }
          
            &.gift-image {
              .image-size {
                width: 220px;
              }
            }
          
          }
        }
      `,
    accordion: `
      .mantine-UnstyledButton-root {
        padding: 0;
        ${vars.breakpoints.sm} {
          padding: 0 16px;
        }
      }
      .mantine-Accordion-content {
        padding: 1rem 0;
        padding-top: calc(0.625rem / 2);
        ${vars.breakpoints.sm} {
          padding: 1rem;
          padding-top: calc(0.625rem / 2);
        }
      }
      .mantine-Accordion-label {
        padding: 24px 0;
      }
      .subscription-option-accordion{
        position: relative;
        .mantine-Accordion-item {
          border: none;
        }
        .mantine-Accordion-item::before {
          content: "";
          left: -16px;
          right: -16px;
          height: 1px;
          background-color: ${vars.colors.secondary9};
          position: absolute;
          ${vars.breakpoints.sm} {
              left: 0px;
              right: 0px;
          }
        }
        transform: rotate(0deg);
        &.single-frequency{
          & .mantine-Accordion-chevron {
            visibility: hidden;
            }
          }
            & .accordion-heading{
              display:flex;

              align-items: center;
              gap: 16px;
            .accordion-heading-text{
              font-size:16px;
              font-weight: ${vars.fonts.weightBold};
              font-family: ${vars.fonts.familySecondary};
            }
            .single-frequency-text{
              color:${vars.colors.lwDrGray};
              display: none;
              ${vars.breakpoints.sm} {
                 display: initial;
              }
            }
          }
          & .option-heading{
            margin-top:10px;
            margin-bottom:20px;
            font-size:16px;
            font-weight: ${vars.fonts.weightNormal};

          }
             & .choosing-weeks{
               // display:flex;
               display: grid;
               grid-auto-flow: row;
               grid-auto-columns: minmax(150px, 1fr); /* Define minimum and maximum column sizes */
               gap:20px;
               align-items: unset;
              ${vars.breakpoints.md} {
                grid-template-columns: repeat(3, 1fr);
                &.choosing-frequency{
                  width:80%;
                }
                // grid-auto-flow: column;
               }
              .weeks-chip {
                  //padding: 20px !important;
                  border-radius: 0;
                  width: auto;
                  height: auto;
                  padding: 10px;
                  border: 1px solid ${vars.colors.secondary9};
                  border-radius: 2px;
                  display:flex;
                  align-items: center;
                  // justify-content: center;
                  cursor:pointer;
                  font-size:16px;
                  font-weight: ${vars.fonts.weightNormal};
                  &.active{
                    border: 2px solid ${vars.colors.primary8};

                    font-weight: ${vars.fonts.weightBold};
                    font-family: ${vars.fonts.familySecondary};

                  }
                  .icon{
                    position: absolute;
                    // margin-left:10px;
                    i:before{
                      color:${vars.colors.btnsPrimaryBg};;
                    }
                  }
                  .frequency-varient{
                     margin: auto;
                   padding:0 25px;
                    width: 100%;
                    display: flex;
                    justify-content: center;

                  }

              }

            }
            & .notes{
              display:flex;
              align-items:center;
              gap:10px;
              color:${vars.colors.secondary12};
              margin-top: 20px;
              .notes-text{

              }
            }
            & .update-section{
              display:flex;
              margin-top: 20px;
              justify-content:end;
              .clear {
                background: none;
                font-size: ${vars.fonts.sizeLarge};
                line-height: ${vars.fonts.lineHeightDefault};
                text-decoration-line: underline;

                cursor: pointer;
                border: none;
                box-shadow: none;
                &:hover {
                  background: none;
                  color: #000;
                  text-decoration-line: underline;
                }
              }
              .update{
                width: 10rem;
                ${vars.breakpoints.sm}{
                  width:250px;
                  }
              }
            }
          }
    `,
    winePlanModalWrapper: `
    & .mantine-Modal-inner{
      bottom: unset;
      top: 10rem;
      ${vars.breakpoints.lg} {
      bottom: 0;
      top: 0;
      }
    }
    & .mantine-Paper-root{
      padding:20px;
    & h2.mantine-Modal-title{
    font-size: 30px;
    font-weight: 500;
    }
    .frequency-weeks{
      font-size: 16px;
      margin:20px 0px;
      .bold{
        font-weight: ${vars.fonts.weightMediumPlus};
      }
    }
    .notes{
      margin-bottom:20px
    }
    .close{
      display:flex;
      justify-content:end;
      button{
      width:190px;
      }
    }
  }
    `,
    unlimitedModalWrapper: `
        .mantine-Modal-title {
          font-size: 28px;
          font-weight: ${vars.fonts.weightMediumPlus};
          margin-bottom: 0 !important;

          ${vars.breakpoints.sm} {
            font-size: 30px;
          }
        }

        .mantine-Modal-header {
          align-items: center;
          padding-top: 20px;
        }

        .mantine-Modal-body {
          padding-bottom: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
        }

        .mantine-Modal-content {
          position: absolute;
          padding: 12px;
          padding-top: 0;
          bottom: 0;
          width: 100%;
          min-height: fit-content;
          border-radius: 8px 8px 0 0;
          box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          gap: 12px;

          ${vars.breakpoints.sm} {
            position: relative;
            max-width: 728px;
            width: 100%;
            height: fit-content;
            padding: 24px;
            border-radius: 8px;
            box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
            top: 20%;
          }
        }

        .unlimited-modal-content-wrapper {
          justify-content: space-between;
          gap: 32px;
          ${vars.breakpoints.sm} {
            justify-content: space-evenly;
          }

          .unlimited-icons{
            display:flex;
            align-items: center;
           .notes {
            margin-left: 10px;
          }
           i {
            color: #20513B;
          }
        }

          .unlimited-offers-content {
            padding: 10px 20px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            height: 70px;
            background-image: url("/next/images/unlimited-offer-bg.png");
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            color: white;
            text-align: center;
            font-size: 24px;
            font-style: bold;
          }
        }

        .unlimited-modal-cta-wrapper {
          justify-content: center;
          flex-direction: column-reverse;
          margin-top: 20px;
          ${vars.breakpoints.sm} {
            flex-direction: row;
            justify-content: flex-end;
            margin-top: auto;
          }
        }

        button.unlimited-modal-primary-cta {
          cursor: pointer;
          width: 100%;
          background-color: #117B53;
          color: ${vars.colors.btnsPrimaryColor};
          ${vars.breakpoints.sm} {
            width: auto;
          }

          :hover {
            background-color: #094B32;
            color: ${vars.colors.btnsPrimaryColor};
          }
        }

        button.unlimited-modal-tertiary-cta {
          cursor: pointer;
          text-decoration: underline;
          background-color: transparent;
          border: none;
          color: ${vars.colors.black};
          &:hover {
            text-decoration: none;
            color: ${vars.colors.black};
            background-color: transparent;
            border: none;
          }
          width: 100%;
          ${vars.breakpoints.sm} {
            width: auto;
          }
        }       
    `,

    cancelWineplanSubscriptionModalWrapper: `
        .mantine-Modal-title {
          font-size: 28px;
          font-weight: ${vars.fonts.weightMedium};
          margin-bottom: 0 !important;
          .heading-notes{
            font-size: 14px;
            font-family: ${vars.fonts.roboto};
            font-weight: ${vars.fonts.weightLight};
            line-height:130%;
            text-transform: none;
            letter-spacing: normal;
          }
          ${vars.breakpoints.sm} {
            font-size: 30px;
          }
        }

        .mantine-Modal-header {
          align-items: flex-start;
          padding-top: 20px;
        }

        .mantine-Modal-body {
          padding-bottom: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: calc(100vh - 200px);
          ${vars.breakpoints.sm}
          {
            height: 100%;
          }
        }

        .mantine-Modal-content {
          position: absolute;
          padding: 12px;
          padding-top: 0;
          top: 0;
          bottom:0;
          width:100%;
          height:100%;
          border-radius: 8px 8px 0 0;
          box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          gap: 12px;

          ${vars.breakpoints.sm} {
            position: relative;
            max-width: 728px;
            width: 100%;
            height: fit-content;
            padding: 24px;
            border-radius: 8px;
            box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
            top: 5%;
            bottom: auto;
          }
        }

        .mantine-Radio-radio{
          position:relative;
          background-color:transparent;
          &:checked{
            border-color: #117B53;
          }
        }

        .mantine-Radio-radio::before,
        .mantine-Radio-radio::after{
          position:absolute;
          content:'';
          height:10px;
          width: 10px;
          background: transparent;
          border-radius:50%;
          background-color: transparent;
        }

        .mantine-Radio-radio:checked::before,
        .mantine-Radio-radio:checked::after{
          background-color: #117B53;
        }

        .wineplan-modal-content-wrapper {
          flex:1;
          overflow-y: scroll;
          justify-content: flex-start;
          gap: 32px;
          ${vars.breakpoints.sm} {
            flex: initial;
            overflow-y: visible;
            padding-bottom: 0;
            justify-content: space-evenly;
          }
          .wineplan-icons{
            padding: 16px 16px 16px 0;
            height: 94px;
            display:flex;
            align-items: flex-start;
            ${vars.breakpoints.sm}
            {
              height: 76px;
              padding: 16px 24px 16px 0;
            }
           i {
            color: #222222;
          }
          .notes {
            margin-left: 16px;
            font-family: ${vars.fonts.roboto};
          }
          .notes-heading{
            font-weight: ${vars.fonts.weightBold};
            font-size: 16px;
            font-family: ${vars.fonts.roboto};
            margin-left: 16px;
          }
        }       

        .wineplan-modal-cta-wrapper {
          position: absolute;
          padding-bottom: 20px;
          width:90%;
          bottom: 0;
          background-color: white;
          padding: 20px;
          justify-content: center;
          flex-direction: column;
          ${vars.breakpoints.sm} {
            position: relative;
            width: 100%;
            padding: 0;
            flex-direction: row;
            justify-content: flex-end;
          }
          &.single-button{
            justify-content: center;
            left:0;
            width: 100%;
            box-shadow:0px -5px 40px #00141E1A, 0px 10px 20px #00141E33;
            ${vars.breakpoints.sm}{
              box-shadow: none;
            }
          }
        }

        button.wineplan-modal-primary-cta {
          cursor: pointer;
          width: 100%;
          background-color: #117B53;
          color: ${vars.colors.btnsPrimaryColor};
          ${vars.breakpoints.sm} {
            width: 220px;
          }

          :hover {
            background-color: #094B32;
            color: ${vars.colors.btnsPrimaryColor};
          }
        }

        button.wineplan-modal-tertiary-cta {
          cursor: pointer;
          background-color: transparent;
          color: ${vars.colors.black};
          &:hover {
            color: ${vars.colors.black};
            background-color: transparent;
          }
          width: 100%;
          ${vars.breakpoints.sm} {
            width: 220px;
          }
          &.disabled{
            background-color: #BCBCBC;
          }
        }  

        .cancel-reasons {
          justify-content: space-around;
          flex: 1;
          gap: 16px;
          .radio-group{
            border: 1px solid #BCBCBC;
            border-radius: 4px;
            width: 100%;
            height: 68px;
            ${vars.breakpoints.sm}
            {
              height: 58px;
            }
          }
          .label{
            flex:1;
            font-weight: ${vars.fonts.weightNormal};
            font-size: ${vars.fonts.sizeH4};
            font-family: ${vars.fonts.roboto};
            letter-spacing: 0%;
            line-height: 140%;
          }
          .radio-group:has(input[type="radio"]:checked){
            border: 1px solid #222222;
            label{
              font-weight: ${vars.fonts.weightBold};
            }
          }
        }

        .coupon-container{
          height: 179px;
          width: fit-content;
          gap:32px;
          padding: 32px;
          ${vars.breakpoints.sm} {
            gap: 16px;
            height: 68px;
            width: 664px;
            padding: 0;
          } 
        }
        
        .coupon{
          position:relative;
          background-color: #004D86;
          height:68px;
          width:193px;
          border-radius: 4px;
          justify-content: center;
          color: #ffffff;
          .mantine-Text-root{
            font-family: Oswald;
            font-weight: ${vars.fonts.weightMedium};
            letter-spacing: -4%;
            line-height: 105%;
            font-size:30px;
            border-left:10px;
          }
        }

        .coupon::before,
        .coupon::after{
          content: '';
          position: absolute;
          width: 20.53px;
          height: 20px;
          top: 50%; /* Center vertically */
          background-color: #ffffff;
          transform: translateY(-50%);
          border-radius: 50%;
        }
        
        .coupon::before{
          left: -10.55px;
        }
        
        .coupon::after{
          left: 182.72px;
        }

        .coupon-notes{
          text-weight: ${vars.fonts.weightBold};
          font-size: 30px;
          font-family: Oswald;
          letter-spacing: -2%;
          line-height:110.00000000000001%
        }
        .features-grid{

        }
        .features-card{
          height: 221px;
          border: 1px solid #BCBCBC;
          border-radius: 4px;
          padding: 24px;
          width: 99%;
          ${vars.breakpoints.sm}
          {
            width: 49%;
            padding: 17px;
            height:181px;
          }
        }
        .feature-title{
          font-size: 16px;
          font-weight: ${vars.fonts.weightBold}; 
          font-family: ${vars.fonts.roboto};
          letter-spacing: 0%;
          line-height: 140%;
        }
        .feature-description{
          letter-spacing: 0%; 
          line-height: 130%; 
          font-family: ${vars.fonts.roboto};
          font-size:14px;
          font-weight: ${vars.fonts.weightNormal}
        }
        .feature-button{
          width: 100%;
          border-radius: 1px;
          height: 43px;
          padding: 0
        }
        .feedback-text-area{
          resize: none;
          width: 100%;
          border: 1px solid ${vars.colors.black};
          & + label {
            color: ${vars.colors.secondary15};
            top: 20px;
          }
        }
        .feedback-notes{
          margin-top: 32px;
        }
        .tick-circle{
          height: 40px;
          background-color: ${vars.colors.secondary16};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 40px;
        }
    `,

    delayCaseModalModalWrapper: {
      wrapper: `
          .mantine-Modal-inner {
            z-index: 9999;
          }
          section.mantine-Paper-root {
            min-height: -webkit-fill-available;
          }
          .mantine-Modal-content {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            min-height: 100vh;
            border-radius: 0;
            & .mantine-Modal-body {
              padding: 0rem 24px;
            }
          }
          .modal-content {
            position: relative;
            display: flex;
            flex-direction: column;
            height: 100vh;        
          }
          .delivery-content {
            position: relative;
            flex: 1;
            .title {
              ${vars.mixins.body1}
              font-weight: ${vars.fonts.weightBold};
              padding-bottom: 1rem;
              text-align: center;
            }
          }
          .title-content {
            display: flex;
            background: #FFF;
            padding-top: 32px;
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
            .title {
              flex: 1;
              text-align: center;
              margin-right: 24px;
            }
          }
          .subtitle {
            ${vars.mixins.body1}
            padding: 1rem 0;
            span {
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .delay-caseoption-container {                 
              .delay-caseoption-details {
                display: flex;
                align-items: center;
                border: 1px solid ${vars.colors.secondary9};
                cursor: pointer;
                padding: 8px 16px;
                margin: 8px 0;
                &.selected {
                  border: 1px solid ${vars.colors.primary8};
                }      
                .delay-caseoption-week {
                  font-weight: ${vars.fonts.weightBold};
                }
              }          
              .delay-caseoption-checkmark {
                color: green;
                margin-right: 8px;
              }
           }
          .button-container {
            text-align: right;
            padding: 16px 0;
            background: #FFF;
            z-index: 100;
            align-items: center;
            position: sticky;
            bottom: 0;
            width: 100%;
            & button {
             cursor: pointer;
            }
            .submit-button {
              width: 100%;  
              padding: 16px; 
              text-transform: uppercase;
              background: ${vars.colors.btnsPrimaryBg};
              .mantine-Button-icon {
                width: 16px;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
            }
          }
        `,
    },
    changeDeliveryDateModalWrapper: {
      wrapper: `
          .mantine-Modal-inner {
            z-index: 9999;
            .error{
              margin-top:16px;
              padding:18px;
              background-color:${vars.colors.errorLight};
              color:${vars.colors.error};
            }
          }
          .spinner {
            min-height: 150px;
            position: relative;
            margin-top: 70px;
          }
          .no-options {
            ${vars.mixins.body1}
            padding: 32px;
            text-align: center;
          }
          .delay-case-option-content {
            margin-top: 12px;
            .delay-case-option-header {
              display: flex;
              align-items: center;
              margin-top: 12px;
              gap: 12px;
              ${vars.mixins.body1}
                .delay-caseoption-week {
                  font-weight: ${vars.fonts.weightBold};
              }
            }
            .delay-case-selected-option {
              flex: 1;
              .mantine-Menu-dropdown {        
                max-height: 200px;
                overflow-y: scroll;    
                padding: 0.75rem;
                margin-top: -9px;  
                border-color: ${vars.colors.secondary9};   
                .mantine-Menu-itemLabel {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .delay-caseoption-container {
              display: flex;
              align-items: center;
              border: 1px solid ${vars.colors.secondary9};
              cursor: pointer;
              padding: 8px;
              justify-content: space-between;
              .delay-caseoption-details {
                flex: 1;
              }            
              .delay-caseoption-checkmark {
                margin-right: 8px;
                color: green;
              }
            }
            .delay-caseoption-menu {
              display: flex;
              align-items: center;
              gap: 8px;
              cursor: pointer;
              justify-content: space-between;
              .delay-caseoption-menu-details {
                flex: 1;
              }            
              .delay-caseoption-menu-checkmark {
                margin-right: 8px;
                color: green;
              }
            }
          }
          .choose-date-option-content {
            margin-top: 12px;
            .choose-date-option-title {
              display: flex;
              align-items: center;
              margin-top: 12px;
              gap: 12px;
              ${vars.mixins.body1}
              .choose-date-date {
                font-weight: ${vars.fonts.weightBold};
              }
            }
            .choose-date-option-subtitle {
              margin-top: 12px;
              color: ${vars.colors.secondary12};
              ${vars.mixins.body1}
              .choose-date-date {
                padding-left: 8px;
              }
            }
            .choose-date-calendar {
              .mantine-MonthLevel-monthLevel {
                margin: auto;
              }
              .mantine-Day-day.weekend {
                color: ${vars.colors.primary5};
              }
              margin-top: 12px;
            }
          }
          .send-now-option-content {
            display: flex;
            align-items: center;
            margin-top: 12px;
            gap: 12px;
            ${vars.mixins.body1}
            .send-now-date {
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .mantine-Modal-content {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            border-radius: 0;
            ${vars.breakpoints.sm} {
              border-radius: 12px; 
              position: static;
            }
            & .mantine-Modal-body {
              padding: 0rem 24px;
            }
          }
          .modal-content {
            position: relative;
            display: flex;
            flex-direction: column;
            ${vars.breakpoints.sm} {
              padding: 0 16px;
              display: block;
              height: 520px;
            }          
          }
          .delivery-content {
            position: relative;
            flex: 1;
          }
          .title-content {
            display: flex;
            justify-content: space-between;
            background: #FFF;
            padding-top: 32px;
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
          }
          .subtitle {
            ${vars.mixins.body1}
            span {
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .option {
            padding: 16px;
            border: 1px solid ${vars.colors.secondary9};
            margin: 16px 0;
            display: flex;
            align-items: flex-start;
            label {
              ${vars.mixins.body1}
              cursor: pointer;
              display: inline-block;
              width: 100%;
            }
            input {
              appearance:none;
              background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" fill="white" stroke="%23BCBCBC"/></svg>');
              background-size: 16px;
              width: 16px;
              height: 16px;
              position: relative;
              top: 3px;
              &:checked {
                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" fill="white" stroke="${encodeURIComponent(vars.colors.primary1)}"/><circle cx="7.99935" cy="8.00002" r="5.33333" fill="${encodeURIComponent(vars.colors.primary1)}"/></svg>');
              }
              /* Green color for "Choose a specific day" radio button */
              &#deliveryDate:checked {
                background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" fill="white" stroke="${encodeURIComponent(vars.colors.secondary17 || '#388e3c')}"/><circle cx="7.99935" cy="8.00002" r="5.33333" fill="${encodeURIComponent(vars.colors.secondary17 || '#388e3c')}"/></svg>');
              }
            }
            &.active{
              border: 1px solid ${vars.colors.primary8};
              label {
                font-weight: ${vars.fonts.weightBold};
              }
            }
          }
          .option-details {
            margin-left: 16px;
            flex: 1;
          }
          .button-container {
            text-align: right;
            padding: 16px 0;
            background: #FFF;
            z-index: 100;
            align-items: center;
            position: sticky;
            bottom: 0;
            width: 100%;
            & button {
             cursor: pointer;
            }        
            .cancel-button {
              background: transparent;
              color: ${vars.colors.primary8};
              border: none;
              border-radius: 0;
              padding: 0 16px;
              display: none;
              span {
                border-bottom: 1px solid ${vars.colors.primary8};
                 ${vars.mixins.body1}
              }
              ${vars.breakpoints.sm} {
                display: inline-block;
              }
            }
            .submit-button {
              width: 100%;  
              padding: 16px; 
              text-transform: uppercase;
              background: ${vars.colors.btnsPrimaryBg};    
              ${vars.breakpoints.sm} {
                width: 180px;
                margin-left: 16px;
              }
              .mantine-Button-icon {
                width: 16px;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
            }
          }
        `,
    },
    deliveryDateConfirmationModalWrapper: {
      wrapper: `
          .mantine-Modal-content {                
            min-width: 70%;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            min-height: 100vh;
            border-radius: 0;
            ${vars.breakpoints.sm} {
              min-width: 60%;
              border-radius: 12px;  
              position: static;
              min-height: initial;
            }
            & .mantine-Modal-body {
              padding: 0rem 1rem ;
            }
          }
          .modal-content {
            position: relative;
            text-align: center;
            ${vars.breakpoints.sm} {
              padding: 0 16px;
              text-align: initial;
            }          
          }
          .delivery-content {
            position: relative;
            .delivery-icon {
              display: inline-block;
              padding: 1rem;
              background: #C3E9CF;
              border-radius: 3rem;
              margin: 48px 0;
              i {
                border: 1px solid ${vars.colors.grey60};
                padding: 5px;
                border-radius: 3rem;
              }
              ${vars.breakpoints.sm} {
                display: none;
              }
            }
            .title {
              margin-bottom: 24px;
              ${vars.breakpoints.sm} {
                display: none;
              }
            }
            .split {
              display: none;
              ${vars.breakpoints.sm} {
                display: inline;
              }
            }
            .subtitle-details {
              display: block;
              padding-top: 16px;
              ${vars.breakpoints.sm} {
                display: inline;
              }
            }
          }
          .title-content {
            display: flex;
            justify-content: flex-end;
            background: #FFF;
            padding-top: 32px;
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
            .title {
              display: none;
              ${vars.breakpoints.sm} {
                display: block;
              }
            }
            ${vars.breakpoints.sm} {
                justify-content: space-between;
            }
          }
          .subtitle {
            ${vars.mixins.body1}
            span {
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .information-text {
            ${vars.mixins.body1}
            padding:16px 0;
            color: ${vars.colors.secondary15};
            .spinner {
              display: inline-block;
              margin-left: 8px;
              position: relative;
              top: 7px;
            }
          }
          .button-container {
            text-align: right;
            padding: 16px 0;
            background: #FFF;
            z-index: 100;
            align-items: center;
            position: sticky;
            bottom: 0;
            width: 100%;
            & button {
             cursor: pointer;
            } 
            .submit-button {
              width: 100%;  
              text-transform: uppercase;
              ${vars.breakpoints.sm} {
                width: 180px;
                margin-left: 16px;
              }
              .mantine-Button-icon {
                width: 16px;
              }
            }
          }
        `,
    },
    deliveryResetConfirmationModalWrapper: {
      wrapper: `
          .mantine-Modal-content {                
            min-width: 70%;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            min-height: 100vh;
            border-radius: 0;
            ${vars.breakpoints.sm} {
              min-width: 60%;
              border-radius: 12px;  
              position: static;
              min-height: initial;
            }
            & .mantine-Modal-body {
              padding: 0rem 1rem ;
            }
          }
          .modal-content {
            position: relative;
            text-align: center;
            ${vars.breakpoints.sm} {
              padding: 0 16px;
              text-align: initial;
            }          
          }
          .delivery-content {
            position: relative;
            .subtitle {
              ${vars.mixins.body1}
              padding-bottom: 24px;
              color: ${vars.colors.secondary15};
            }
          }
          .title-content {
            display: flex;
            justify-content: flex-end;
            background: #FFF;
            padding-top: 32px;
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
            ${vars.breakpoints.sm} {
                justify-content: space-between;
            }
          }
          .button-container {
            text-align: right;
            padding: 16px 0;
            background: #FFF;
            z-index: 100;
            align-items: center;
            position: sticky;
            bottom: 0;
            width: 100%;
            border-radius: 2px;
            & button {
             cursor: pointer;
            } 
            .cancel-button {
              background: transparent;
              color: ${vars.colors.primary8};
              border: ${vars.colors.primary8} solid 1px;
              margin-bottom: 16px;
              width: 100%;
              text-transform: uppercase;
              ${vars.breakpoints.sm} {
                width: auto;
                margin-right: 16px;
              }
            }
            .submit-button {
              width: 100%;  
              text-transform: uppercase;
              ${vars.breakpoints.sm} {
                width: auto;
                margin-left: 0;
              }
              .mantine-Button-icon {
                width: 16px;
              }
            }
          }
        `,
    },
    pushbackSaveOfferModalWrapper: {
      wrapper: `
       .mantine-Modal-content {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            min-height: 100vh;
            border-radius: 0;
            ${vars.breakpoints.sm} {
              border-radius: 12px; 
              min-width: 50%;
              position: static;
              min-height: initial;
            }
          
          }
          .modal-content {
            position: relative;
            display: flex;
            flex-direction: column;
            height: 100vh;
            ${vars.breakpoints.sm} {
              padding: 16px;
              display: block;
              height: initial;
            }          
          }
                display: flex;
            justify-content: space-between;
            background: #FFF;
            padding-top: 32px;
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              cursor: pointer;
            }
              & .title-content {
            display: flex;     
            background: #FFF;       
            z-index: 100;          
            position: sticky;
            top: 0;
            width: 100%;
            & i {margin-bottom: 16px;
              cursor: pointer;
            }
            .title {
             
              ${vars.breakpoints.sm} {
                display: block;
              }
            }
            ${vars.breakpoints.sm} {
                justify-content: space-between;
            }
           }
          }
          .pushback-save-modal-content-wrapper {
            .offer-notes{
              font-family: ${vars.fonts.familySecondary};
              font-weight: ${vars.fonts.weightNormal};
              margin-top: 4px;
            }
            justify-content: space-between;
            
            ${vars.breakpoints.sm} {
              justify-content: space-evenly;
          }

          .unlimited-icons{
            display:flex;
            align-items: center;
           .notes {
            margin-left: 10px;
          }
           i {
            color: #20513B;
          }
        }
          
        .pushback-save-offers-content{
          gap: 10px;
          flex-direction: column;
          width:100%;
           ${vars.breakpoints.md} {
                flex-direction: row;
            }
         

          .offer-batch {
            padding: 10px 30px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            height: 68px;
            background-image: url("/next/images/cancel-save-offer-bg.png");
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            color: white;
            text-align: center;
            .offer-batch-text{
              font-family: ${vars.fonts.familyPrimary} !important;
              font-size: ${vars.fonts.fontSize24};
              ${vars.breakpoints.xl} {
                  font-size: ${vars.fonts.fontSize30};
              }
               font-weight: ${vars.fonts.weightMedium};
             }
          }
            .offer-right-content{
            font-family: ${vars.fonts.familyPrimary} !important;
             font-size: ${vars.fonts.fontSize24};
            ${vars.breakpoints.xl} {
                font-size: ${vars.fonts.fontSize30};
            }

                font-weight: ${vars.fonts.weightMedium};
            }
          }
                .push-save-modal-cta-wrapper{
          button.pushback-save-modal-primary-cta{
            order: 1;
          }
          button.pushback-save-modal-tertiary-cta{
            order: 2;
            font-size: ${vars.fonts.fontSize16};
            }
          ${vars.breakpoints.sm} {
          button.pushback-save-modal-primary-cta{
            order: 2;
          }
          button.pushback-save-modal-tertiary-cta{
            order: 1;
            }
          }
          justify-content: end;
          
          button.pushback-save-modal-primary-cta {
          cursor: pointer;
          width: 100%;
          ${vars.breakpoints.sm} {
            width: auto;
          }

          :hover {
            background-color: #094B32;
            color: ${vars.colors.btnsPrimaryColor};
          }
        }

        button.pushback-save-modal-tertiary-cta {
          cursor: pointer;
          text-decoration: underline;
          background-color: transparent;
          border: none;
          color: ${vars.colors.black};
          &:hover {
            text-decoration: none;
            color: ${vars.colors.black};
            background-color: transparent;
            border: none;
          }
          width: 100%;
          ${vars.breakpoints.sm} {
            width: auto;
          }
        } 
    }
        `,
    },
    winePlanBeyondLabel: `
      & .mantine-Modal-close{
         color: ${vars.colors.primary8};
         &:focus {
                  outline: none;
           }
      }
      .mantine-Modal-inner {
              z-index: 9999;
              background-color: rgba(0, 0, 0, 0.2);

      }
      & .mantine-Modal-header{
            padding-bottom: 5px;
      & h2.mantine-Modal-title{
        font-family: ${vars.fonts.oswald};
        font-size: 34px;
        font-weight: 500;
        line-height: 35.7px;
        letter-spacing: -0.03em;
        text-align: left;
        
      }
     }
      .header-container {
        display:flex;
        flex-direction:column;
        .wine-rating{
          display: flex;
          align-items: center;
          gap:10px;
           margin-bottom: 15px;
           .star-icons{
            margin-top: 0.4rem;
           }
           .review-count{
             cursor:pointer;
             text-decoration: underline;
            & a{
               text-decoration: none;
            }
           }
        }
        .appellation-name{
          font-size: 22px;
          text-transform: capitalize;
        }
           .web-description {
            // font-size:16px;
            ${vars.mixins.body1}
              margin-bottom: 10px;
           }
      }
      .beyond-label-case-details{
              margin-top: 20px;
              text-align: left;
              @media (min-width: 768px) {
                display: grid;
                grid-template-columns: 2fr 1fr 2fr;
              }

              & .sub-title-with-border {
                font-family: ${vars.fonts.familyTertiary};
                font-size: 30px;
                font-style: normal;
                text-transform: capitalize;
                font-weight: ${vars.fonts.weightMediumPlus};
                line-height: 120%; /* 36px */
                letter-spacing: -0.3px;
                padding-bottom: 10px;
                border-bottom: 1px solid #ccc;
                margin-bottom: 25px;
                
              }
              & ul{
                  gap:15px;
                 li{
                     font-size: 16px;
                     display: grid;
                     grid-template-columns: 0.1fr 1fr;
                 }
                }
              .image-container{
                display:flex;
                justify-content: center;
               .image-size {
                position:relative;
                 width:120px;
                 height: 370px;
                text-align: center;
              }
            }
            
            }
            & .case-details{
              &  .item-title {
                 font-family: ${vars.fonts.familySecondary};
                ${vars.mixins.h8}
                ~.item-sub-title{
                      font-size: 16px;
                }
              }

            }
            & .wine-details{
              font-family: ${vars.fonts.familySecondary};
              font-size: 16px;
              font-weight: ${vars.fonts.weightNormal};
              line-height: 22.4px;
              text-align: left;
            }
            // mobile
            & .mantine-Accordion-item{
                     box-shadow: 0px -1px 0px 0px ${vars.colors.secondary14} inset;
                     border-bottom: none;
                 }
                   &  .mantine-Accordion-label {
                     font-weight: ${vars.fonts.weightBold};
                     font-size: ${vars.fonts.sizeLarge};
                     font-family: ${vars.fonts.familyTertiary};
                   }
              & .product-details-mobile-view{
                           display:block;
                        ${vars.breakpoints.sm} {
                          display:none;
                          }
                          & .mantine-Accordion-chevron{
                            & svg{
                                  width: 3rem !important;
                                height: 3rem !important;
                            }
                          }
                          .description{
                            margin:15px 0px;
                            font-family: ${vars.fonts.familySecondary};
                             font-size: ${vars.fonts.fontSize16};

                                  font-weight: ${vars.fonts.weightNormal};
                           
                            text-align: center;
                            box-shadow: 0px -1px 0px 0px ${vars.colors.secondary14} inset;
                            border-radius: 3px;
                          }
                            & .see-more-description{
                            background: none;
                            color: ${vars.colors.grey50};
                            line-height: 24px;
                            font-size: ${vars.fonts.sizeH4};
                            padding: 0;
                            text-decoration-line: underline;
                            cursor: pointer;
                            margin: 15px 0;
                            box-shadow: none;
                            border: none;
                            font-weight: 500;
                             font-family: ${vars.fonts.familySecondary};
                          }

                          
                          
                          & .image-container {
                            &.about-producer {
                              position: relative;
                              min-height: 300px;
                            }
                          }

                      }

                    .product-details{
                      text-align:center;
                        
                      .product-name{
                        font-size: 18px;
                        font-weight: ${vars.fonts.weightMediumPlus};
                        margin: 18px 0 15px 0;
                        font-family: ${vars.fonts.familyTertiary};
                        margin-top: 10px;
                      }
                     .product-count{
                        color: ${vars.colors.grey60};
                        font-size: 16px;
                        font-weight: ${vars.fonts.weightNormal};
                        padding-bottom: 15px;
                        align-items: center;
                        display: flex;
                        justify-content: center;

                      }
                    }                     
      `,
    manageAddress: {
      headerWrapper: `
          &.header {
            text-align: center;
            margin-bottom: ${vars.space.lg};
          }
          .header-title {
            text-transform: uppercase;
          }
          .header-information {
            ${vars.mixins.body1}
            span {
              font-weight: ${vars.fonts.weightMediumPlus};
            }
          }
        `,
      wrapper: `      
          .loading-page {
            margin: 2rem 0;
          }
          .add-new-address {
            margin: 24px 0 0;
            cursor: pointer;
            width: 100%;
            font-weight: ${vars.fonts.weightMediumPlus};
            line-height: initial;
            text-transform: uppercase;
            ${vars.breakpoints.sm} {
              width: initial;
            }
          }
          .add-address-success {  
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 12px;
            background: #C3E9CF;
            padding: 12px;
            border-radius: 4px;
            font-size: ${vars.fonts.sizeSmall};
            font-weight: ${vars.fonts.weightMedium};
          }
        `,
      userDefaultAddress: `
          .addresses {
            display: flex;
            gap: 16px;
            flex-direction: column;
            ${vars.breakpoints.sm} {
              width: initial;
              flex-direction: row;
            }
          }
        `,
      defaultAddress: `
          &.address-section {
            background-color: ${vars.colors.primary3};
            flex: 1;
            padding: 24px;
          }
          .loading {
            margin: 24px 0;
          }
          .name {
            ${vars.mixins.body1}
            font-weight: ${vars.fonts.weightBold};
          }
          .address {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }       
          .line1, .line2, .instructions {
            ${vars.mixins.body1}
          }
          .instructions span{
            font-weight: ${vars.fonts.weightBold};
          }
          & a {
            padding: 12px 0;
            display: inline-block;
            &:hover, &:active, &:focus {
              text-decoration: none;
            }
            & .link-text {
              text-decoration: none;
              border-bottom: 1px solid ${vars.colors.primary8};
              font-size: ${vars.fonts.sizeH5};
              font-weight: bold;
              text-transform: uppercase;
            }
          }
        `,
      postalAddressSelector: `
          .address-content {      
              padding: 0 24px;
          }
          .address-selector {
              display: flex;
              align-items: center;
              margin: 12px 0;
              gap: 12px;
              ${vars.mixins.body1}
            }
            .result-count {
              ${vars.mixins.body1}
              font-weight: ${vars.fonts.weightBold};
            }
            .mantine-Menu-item {
              color: ${vars.colors.secondary15};
            } &:focus {
                  outline: none;
                  }
            .address-selector-container{
              flex: 1;
            }
            .address-selector-title {
              color: #767676;
            }
            .mantine-Menu-dropdown {        
                max-height: 200px;
                overflow-y: scroll;  
                width: calc(100% - 70px) !important;       
                .mantine-Menu-itemLabel {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                } &:focus {
                  outline: none;
                  }
              }
            .address-selector-container {
              display: flex;
              align-items: center;
              border: 1px solid ${vars.colors.secondary9};
              cursor: pointer;
              padding: 8px;
              justify-content: space-between;
              .delay-caseoption-details {
                flex: 1;
              }            
              .address-selector-menu-checkmark {
                margin-right: 8px;
                color: green;
              }
            }
            .address-selector-menu {
              display: flex;
              align-items: center;
              gap: 16px;
              white-space: normal;
              cursor: pointer;
              justify-content: space-between;
              .delay-caseoption-menu-details {
                flex: 1;
              }            
              .address-selector-menu-checkmark {
                margin-right: 8px;
                color: green;
              }
            }
        `,
      addAddressModalWrapper: `
          .noResultsError {  
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 24px;
            background: ${vars.colors.primary7};
            padding: 12px;
            border-radius: 4px;
            font-size: ${vars.fonts.sizeSmall};
            font-weight: ${vars.fonts.weightMedium};
          }
          .mantine-Modal-inner {
            z-index: 9999;
          }
          .mantine-Modal-content {
            position: fixed;
            top: 150px;
            left: 0;
            width: 100%;
            height: calc(100vh - 150px);
            scrollbar-color: ${vars.colors.grey40} transparent;
            ${vars.breakpoints.sm} {
              border-radius: 12px; 
              min-width: min(90%, 725px);
              position: static;
              min-height: initial;
              height: initial;
            }
            & .mantine-Modal-body {
              padding: 0;
            }
          }
          .modal-content {
            display: flex;
            flex-direction: column;
            ${vars.breakpoints.sm} {
              display: block;
            }
            .postal-text {
             ${vars.mixins.body1}
             margin-bottom: 24px;
            }
            .content-section {
              padding: 0 24px;
              ${vars.breakpoints.sm} {
                padding: 0 32px;
              }
            }
            .form-collapsed ~ div .address-content {
                padding: 24px 24px;
                ${vars.breakpoints.sm} {
                  padding: 0 24px 24px;
                }
            } 
            .form-collapsed {
              .button-container {
                position: absolute;
                bottom: 0;
                width: calc(100% - 48px);
                ${vars.breakpoints.sm} {
                  position: static;
                  width: initial;
                }
              }      
            }
            .title-content {
              padding: 0 24px;
              ${vars.breakpoints.sm} {
                padding: 32px 32px 0;
              }
              display: flex;
              background: #FFF;
              padding-top: 32px;
              align-items: center;
              z-index: 100;
              position: sticky;
              top: 0;
              width: 100%;
              & i {
                margin-bottom: 16px;
                cursor: pointer;
              }
              .title {
                flex: 1;
                margin-right: 24px;
              }
            }
            .submit-address {
                position: sticky;
                margin: 0;
                bottom: 0;
                left: 0;
                padding: 10px 24px;
                z-index: 2;
                background: white;
                box-shadow: 0px -5px 40px 0px #00141E1A;
                box-shadow: 0px 10px 20px 0px #00141E33;
                ${vars.breakpoints.sm} {
                  box-shadow: none;
                  padding: 10px 32px 32px;
                }
                .mantine-Grid-col {
                  margin-bottom: 8px;
                }
            }
            .button-container {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              margin: 16px 0;
              gap: 8px;
              flex-direction: column-reverse;
              ${vars.breakpoints.sm} {
                  box-shadow: none;
                  flex-direction: initial;
                  margin: 32px 0;
                  gap: 24px;
              }
              & button {
              cursor: pointer;
              }
              .add-manual-address {
                padding: 1rem;
                cursor: pointer;
                text-decoration: underline;
              }
              .submit-button {
                width: 100%;  
                padding: 16px; 
                text-transform: uppercase;
                background: ${vars.colors.btnsPrimaryBg};    
                ${vars.breakpoints.sm} {
                  width: 180px;
                  margin-left: 16px;
                }
                .mantine-Button-icon {
                  width: 16px;
                }
                &:disabled{
                  background-color: ${vars.colors.grey00};
                  color: ${vars.colors.grey70};
                }
              }
            }         
          }
        `,
      addAddressForm: `
         .submit-button {
              width: 100%;  
              padding: 16px;
              margin: 0 7px;
              text-transform: uppercase;
              background: ${vars.colors.btnsPrimaryBg};
              .mantine-Button-icon {
                width: 16px;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
          }
         .mantine-InputWrapper-label span.required {
           color: ${vars.colors.primary9}; 
         }
         .mantine-InputWrapper-label span.optional {
            color: ${vars.colors.secondary15};
         }
         .add-address-error {  
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 12px;
            background: ${vars.colors.primary7};
            padding: 12px;
            border-radius: 4px;
            font-size: ${vars.fonts.sizeSmall};
            font-weight: ${vars.fonts.weightMedium};
          }
         .mantine-InputWrapper-error {
           color: #AA182B;
          }
          .mantine-Input-input[data-invalid] {
            color: #AA182B;
            border-color: #AA182B;
          }
          .update-all-delivery-checkbox{    
              margin-right:10px;
              & input:checked{
                border-color: ${vars.colors.secondary6};
                background-color: ${vars.colors.secondary6};
              }
            }
          .add-address-form-section {
            padding: 0 24px;
            margin: 0;  
            margin-bottom: 16px;
            ${vars.breakpoints.sm} {
              margin: 0;   
              padding: 0 32px;   
            }
          }
        `,
      addAddressConfirmationModalWrapper: {
        wrapper: `
          .mantine-Modal-content {                
            min-width: 70%;
            position: fixed;
            top: 150px;
            left: 0;
            width: 100%;
            height: calc(100vh - 150px);
            ${vars.breakpoints.sm} {
              min-width: min(90%, 725px);
              border-radius: 12px;  
              position: static;
              height: initial;       
            }
            & .mantine-Modal-body {
              padding: 0rem;
            }
          }
          .modal-content {
            position: relative;
            text-align: center;
            ${vars.breakpoints.sm} {
              padding: 0;
              text-align: initial;
            }          
          }
          .delivery-content {
            position: relative;
            .delivery-icon {
              display: inline-block;
              padding: 1rem;
              background: #C3E9CF;
              border-radius: 3rem;
              margin: 48px 0;
              i {
                border: 1px solid ${vars.colors.grey60};
                padding: 5px;
                border-radius: 3rem;
              }
              ${vars.breakpoints.sm} {
                display: none;
              }
            }
            .title {
              margin-bottom: 24px;
              ${vars.breakpoints.sm} {
                display: none;
              }
            }
            .split {
              display: none;
              ${vars.breakpoints.sm} {
                display: inline;
              }
            }
            .subtitle-details {
              display: block;
              padding-top: 16px;
              ${vars.breakpoints.sm} {
                display: inline;
              }
            }
          }
          .content-section {
            position: fixed;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            overflow: hidden;
            padding: 0 24px;
            ${vars.breakpoints.sm} {
              padding: 0 32px;
            }
            width: 100%;
            ${vars.breakpoints.sm} {
                position: static;
                transform: initial;
                width: initial;
            }
          }
          .title-content {
            display: flex;
            justify-content: flex-end;
            background: #FFF;
            padding: 32px 24px 0;
            ${vars.breakpoints.sm} {
              padding: 32px 32px 0;
            }
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
            .title {
              display: none;
              ${vars.breakpoints.sm} {
                display: block;
              }
            }
            ${vars.breakpoints.sm} {
                justify-content: space-between;
            }
          }
          .subtitle {
            ${vars.mixins.body1}
            span {
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .button-container {
            text-align: center;
            padding: 32px 0;
            background: #FFF;
            z-index: 100;
            align-items: center;
            position: sticky;
            bottom: 0;
            width: 100%;
            ${vars.breakpoints.sm} {
              text-align: right;
              padding: 16px 0;
            }
            & button {
             cursor: pointer;
            } 
            .submit-button {
              text-transform: uppercase;
              width: 180px;
              ${vars.breakpoints.sm} {
                margin-left: 16px;
              }
              .mantine-Button-icon {
                width: 16px;
              }
            }
          }
        `,
      },
      addressBook: `
          .address-book-addresses {
            position: relative;
            display: grid;
            grid-template-columns: 1fr;
            gap: 0;
            ${vars.breakpoints.sm} {
              grid-template-columns: 1fr 1fr;   
              gap: 16px;
            }       
          }
          .address-section {
            margin: 16px 0;
            ${vars.breakpoints.sm} {
              margin: 32px 0;
            }
          }
          .address-book-subtitle {
            display: flex;
            margin: 16px 0;
            gap: 8px;
          }
          .address-book-card {
            border: none;
            ${vars.breakpoints.sm} {
              border: 1px solid ${vars.colors.secondary9};    
            }
            position: relative;
          }
          .address-divider {
            border-bottom: 1px solid ${vars.colors.secondary9};
            position: absolute;
            left: -16px;
            right: -16px;
            display: block;
            top: 0;
            ${vars.breakpoints.sm} {
              display: none;      
            }
          }       
          .address-book-subtitle-text {
            ${vars.mixins.body1}
            & a {
              text-decoration: underline;
              margin: 4px;
              ${vars.mixins.body1}
              font-weight: ${vars.fonts.weightMedium};
            }
          }
        `,
      addressBookCard: `
          &.address-book-card-section {
            height: 100%;
            padding: 24px 0;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            ${vars.breakpoints.sm} {
              padding: 24px;    
            }
          }
          .address-card-divider {
            border-bottom: 1px solid ${vars.colors.secondary9};
            position: absolute;
            left: -16px;
            right: -16px;
            display: block;
            bottom: 0;
            ${vars.breakpoints.sm} {
              display: none;      
            }
          }
          .loader {
            margin-top: 24px;
            & .loaderContainer {
              justify-content: flex-start;
              & div {
                width: 20px;
                height: 20px;
                border-width: 3px;
              }
            }
          }
          .name {
            ${vars.mixins.body1}
            font-weight: ${vars.fonts.weightBold};
          }
          .address {
            display: flex;
            flex-direction: column;
            gap: 8px;
            flex: 1;
          }       
          .line1, .line2, .instructions {
            ${vars.mixins.body1}
          }
          .instructions span{
            font-weight: ${vars.fonts.weightBold};
          }
          .delivery-address-change {
            cursor: pointer;
            text-decoration: underline;
            display: inline-block;
            text-transform: uppercase;
            margin: 16px 0 0;
            ${vars.mixins.body1}
            font-weight: ${vars.fonts.weightMediumPlus};
            font-size: 14px;
            ${vars.breakpoints.sm} {
              margin: 24px 0 16px;     
            }
          }
        `,
      collectFromStore: `
          margin: 16px 0;
          ${vars.breakpoints.sm} {
              margin: 32px 0;
          }
          h6.title {
            margin-bottom: 16px;
            ${vars.breakpoints.sm} {
              margin-bottom: 24px;
            }
          }
          .store-form-fields {
            display: flex;
            gap: 16px;
            flex-direction: column;
            .mantine-Input-input {
              height: 40px;
            }
            ${vars.breakpoints.sm} {
              flex-direction: row;
            }
          }
          .store-form-field{
            flex: 1;
          }
          .store-address-error {  
            display: flex;
            align-items: flex-start;
            gap: 8px;
            margin-top: 8px;
            background: #B3CFE5;
            padding: 12px;
            border-radius: 4px;
            font-size: ${vars.fonts.sizeSmall};
            font-weight: ${vars.fonts.weightMedium};
            a {
              text-decoration: none;
              border-bottom: 1px solid ${vars.colors.primary8};
              font-weight: ${vars.fonts.weightMediumPlus};
              &:hover {
                text-decoration:
              }
            }
          }
          .submit-button { 
              padding: 12px 24px;
              height: 40px;
              text-transform: uppercase;
              background: ${vars.colors.btnsPrimaryBg};
              width: 100%;
              .mantine-Button-icon {
                width: 16px;
              }
              ${vars.breakpoints.sm} {
                width: initial;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
          }
      `,
      shopAddress: `
        &.address-section {
          padding-top: 16px;
        }
        .title {
          ${vars.mixins.body1}
          font-weight: ${vars.fonts.weightBold};
          margin-bottom: 8px;
        }
        .address {
          ${vars.mixins.body1}
          margin-bottom: 16px;
        }
      `,
      paymentMethod: `
         margin-bottom: 16px;
         ${vars.breakpoints.sm} {
            margin-bottom: 24px;   
         }
        .payment-message {
          ${vars.mixins.body1}
          margin-bottom: 16px;
          ${vars.breakpoints.sm} {
              margin-bottom: 24px;   
          }       
          span {
            font-weight: ${vars.fonts.weightBold};
          }
        }
      `,
      paymentCard: `
        padding: 16px 16px 12px;
        display: flex;      
        background: ${vars.colors.primary3};
        border-radius: 8px;
        flex-direction: column; 
        justify-content: initial;
        align-items: flex-start;
        ${vars.breakpoints.sm} {
          flex-direction: row; 
          align-items: center;
          justify-content: space-between;
          padding: 0 12px;
          border-radius: 2px;
        }
        ${vars.mixins.body1}
        .card-details {
          display: flex;
          gap: 8px;
          align-items: flex-start;
          padding-bottom: 16px;
          flex-wrap: wrap;
          ${vars.breakpoints.sm} {
            align-items: center;
            padding-bottom: 0;
          }
        }
        .card-details-icon {      
          ${vars.breakpoints.sm} {
            position: relative;
            top: 3px;
          }
        }
        .change-payment-card a {
          font-weight: ${vars.fonts.weightMediumPlus};
          font-size: ${vars.fonts.sizeH5};
          color:${vars.colors.primary8};
          word-break: normal;
          border-bottom: 1px solid ${vars.colors.black};
        }
        .card-type {
          font-weight: ${vars.fonts.weightBold};
        }
        .card-info {
          display: flex;
          gap: 8px;
          flex-direction: column; 
          ${vars.breakpoints.sm} {
            flex-direction: row;
          }
        }
        .card-number-info {
          display: flex;
          gap: 8px;
          flex-direction: row;
        }
      `,
      winePlanCard: `
       margin-bottom: 16px;
       gap: 4px;
       flex-direction: column;
       ${vars.breakpoints.sm} {
          margin-bottom: 24px; 
          gap: 6px;  
          flex-direction: row;
       }
       display: flex;     
       .wine-plan-amount {
         background-color: ${(vars.colors.bgColors as unknown as { [key: string]: string }).whiteWine};
         padding: 32px 16px;
         border-bottom-left-radius: 12px;
         border-bottom-right-radius: 12px;
         ${vars.breakpoints.sm} {
          padding: 32px;
          border-radius: 0;
         }
         display: flex;
         flex: 1;
         flex-direction: column;
         justify-content: center;
         align-items: center;
         gap: 8px;
       }
       h4.wine-plan-balance {
          text-align: center;
          font-size: ${vars.fonts.sizeH3};
          margin-bottom: 8px;
          ${vars.breakpoints.sm} {
            font-size: ${vars.fonts.sizeH9};
            margin-bottom: 16px;
          }
          span {
           color: ${vars.colors.primary9};
          }       
       }
       .wine-plan-opt {
         .mantine-Checkbox-label {
           ${vars.mixins.body2}
         }      
       }
       .wine-plan-opt-checkbox{    
          margin-right:10px;
          border-color: ${vars.colors.secondary6};
          & input{
            border-color: ${vars.colors.secondary15};
          }
          & input:checked{
            border-color: ${vars.colors.secondary6};
            background-color: ${vars.colors.secondary6};
          }
        }
       .wine-plan-logo {
         flex: 1;
         align-self: center;
         img {
           width: 100%;
           ${vars.breakpoints.sm} {
              width: 100%;
           }
         }
       }
      `,
    },
    swapSubscription: {
      wrapper: `
       .swap-subscription-success {  
              display: flex;
              align-items: center;
              gap: 8px;
              background: #C3E9CF;
              padding: 12px;
              border-radius: 4px;
              margin: 12px 0;
              font-size: ${vars.fonts.sizeSmall};
              font-weight: ${vars.fonts.weightMedium};
              ${vars.breakpoints.sm} {             
                margin: 12px;
              }
        }
      `,
      swapCaseLinks: `
        .links-wrapper {
          display: flex;
          gap: 12px;
          a, div.flex-link{
            cursor: pointer;
            text-decoration: none;
            padding: 7px 16px;
            text-transform: uppercase;
            border: 1px solid ${vars.colors.primary8};
            border-radius: 4px;
            ${vars.mixins.body3}
            font-weight: ${vars.fonts.weightMediumPlus};
            line-height: 14px;
            text-align:center;
            width: 100%;
          }
        }
      `,
      headerWrapper: `
          &.header {
            text-align: left;
            margin-top: ${vars.space.lg};
            margin-bottom: ${vars.space.lg};
            ${vars.breakpoints.sm} {
              text-align: center;
              margin-top: 0;
            }
          }
          .header-title {
            text-transform: uppercase;
          }
          .header-information {
            ${vars.mixins.body1}
            span {
              font-weight: ${vars.fonts.weightMediumPlus};
            }
          }
        `,
      caseOptionsAccordion: `
        margin-top: 8px;
        button.mantine-UnstyledButton-root {
            padding: initial;
        }
      `,
      filterWrapper: `
         margin: 32px 0;
         display: flex;
         flex-wrap: wrap;
         justify-content: space-between;
         &.filter-web {
           display: none;
           ${vars.breakpoints.md} {
              display: flex;
           }
         }
         &.filter-mobile {
           margin: 16px 0;
           border: 1px solid ${vars.colors.primary8};
           border-radius: 2px;
           display: flex;
           ${vars.breakpoints.md} {
              display: none;
           }
         }
         .filter-section {        
           display: flex;
           gap: 16px;
         }
         .filter {
           button {
             border: 1px solid ${vars.colors.secondary9};
             padding: 8px 16px;
             color: ${vars.colors.primary8};
             ${vars.mixins.body1}
             span {
               height: fit-content;
             }
           }
           button.selected {
             border: 1px solid ${vars.colors.primary8};
             font-weight: ${vars.fonts.weightBold};
           }
         }
         .quantity-selector {
           .quantity-selector-button {
             border: 1px solid ${vars.colors.secondary9};
             ${vars.mixins.body1}
             color: ${vars.colors.facetCheckboxColor};
             .quantity-label {
              font-weight: ${vars.fonts.weightBold};
              color: ${vars.colors.primary8};
             }
           }
         }
        .quantity-selector-mobile {
           flex: 1;
           .quantity-selector-button {
             width: 100%;
             border: none;
             ${vars.mixins.body1}
             color: ${vars.colors.primary8};
             .quantity-label {
              font-weight: ${vars.fonts.weightBold};
              color: ${vars.colors.primary8};
             }
           }      
           .mantine-Button-label {
             display: flex;
             justify-content: space-between;
             width: 100%;
           }
         }
        .filter-section-mobile {
           flex: 1;
           .filter-section-button {
             width: 100%;
             border: none;
             border-radius: 0;
             border-right: 1px solid ${vars.colors.primary8};
             ${vars.mixins.body1}
             color: ${vars.colors.primary8};
             .quantity-label {
              font-weight: ${vars.fonts.weightBold};
              color: ${vars.colors.primary8};
             }
           }
           .mantine-Button-label {
             display: flex;
             justify-content: space-between;
             width: 100%;
           }
         }
      `,
      selectCaseType: `
        margin-top: 16px;
        ${vars.breakpoints.sm} {
          margin-bottom: 24px;
        }
        display: flex;
        justify-content: space-between;
        .case-type-selection {
          display: flex;
          gap: 12px;
          flex: 1;
          align-items: center;
          & div {
            padding: 5px 12px;
            display: inline-block;
            border: 1px solid ${vars.colors.unlimitedButtonColor};
            ${vars.mixins.body1}
            height: fit-content;
            border-radius: 16px;
            cursor: pointer;
            &.selected {
              background: ${vars.colors.unlimitedButtonColor};
              color: #FFF;
            }
          }
        }
      `,
      caseOptionPrice: `
        display: flex;
        gap: 8px;
        margin-bottom: 12px;
        ${vars.breakpoints.sm} {
          margin-bottom: 16px;
        }
        align-items: center;
        .discount-price {
          ${vars.mixins.body3}
          font-weight: ${vars.fonts.weightMediumPlus};
          color: #D7363B;
          background-color: #fbeaea;
          padding: 4px 10px;
          border-radius: 16px;
        }
        h6.base-price {
          margin-bottom: 0;
        }
      `,
      caseOptions: `
        .lazy-load-item-placeholder {
          height: 300px;
          ${vars.breakpoints.sm} {
            height: 200px;
          }
        }
        .case-types {
          .subscription-option-accordion .mantine-Accordion-item::before {
            content: initial;
          }
        }
        .case-details {
          position: relative;
          margin-bottom: 24px;
          &::after {
            position: absolute;
            content: "";
            border-bottom: 1px solid #BCBCBC;
            width: calc(100% + 32px);
            bottom: 0;
            left: -16px;
            z-index: 2;
            ${vars.breakpoints.sm} {
              width: 100%;
              left: 0;
            }
         }
        }
        .case-description {
          margin-top: 12px;
        }
        .case-fequency {
           ${vars.mixins.body1}
           margin-bottom: 12px;
           ${vars.breakpoints.sm} {
              margin-bottom: 16px;
           } 
        }
        .case-information {     
          margin-top: 8px;  
          padding: 0;
          ${vars.breakpoints.sm} {
              margin-top: 0;
              padding: 0 16px 0 12px;
          }           
          flex: 1;
        }
        .select-subscription { 
          display: none;    
          align-self: flex-end;
          ${vars.breakpoints.lg} {
            display: initial; 
          } 
          .select-subscription-button {
            font-weight: ${vars.fonts.weightMediumPlus};
            border-radius: 2px;
            cursor: pointer;
          }
        }
        .select-subscription-medium-screen {
          display: none;    
          align-self: flex-end;
          ${vars.breakpoints.sm} {
            display: initial; 
          } 
          ${vars.breakpoints.lg} {
            display: none; 
          } 
          .select-subscription-button {
            font-weight: ${vars.fonts.weightMediumPlus};
            border-radius: 2px;
            cursor: pointer;
          }
        }
        .select-subscription-mobile {  
          padding-bottom: 24px;    
          ${vars.breakpoints.sm} {
            display: none; 
          }
          .select-subscription-button {
            font-weight: ${vars.fonts.weightMediumPlus};
            cursor: pointer;
          }
        }
        .case-option {
          position: relative;
          display: flex;
          flex-direction: column;
          ${vars.breakpoints.sm} {
              margin-top: 0;
              flex-direction: row;
          }
          .case-image {  
            height: 250px;
            width: calc(100% + 32px);
            text-align: center;
            position: relative;
            left: -16px;
            ${vars.breakpoints.sm} {
              height: 180px;
              width: 180px; 
              position: static;
            }
            ${vars.breakpoints.md} {
              height: 220px;
              width: 220px; 
            }
            text-align: center;
            img {
               width: 100%;
               height: 100%;
               object-fit: cover;
               ${vars.breakpoints.sm} {
                width: auto; 
              }
              &.default{
                width: auto; 
              }
            }
          }
        }    
      `,
      swapSubscriptionConfirmationModalWrapper: {
        wrapper: `
          .mantine-Modal-content {                
            min-width: 70%;
            position: fixed;
            top: 150px;
            left: 0;
            width: 100%;
            height: calc(100vh - 150px);
            ${vars.breakpoints.sm} {
              min-width: min(90%, 725px);
              border-radius: 12px;  
              position: static;
              height: initial;       
            }
            & .mantine-Modal-body {
              padding: 0rem;
            }
          }
          .modal-content {
            position: relative;
            text-align: center;
            ${vars.breakpoints.sm} {
              padding: 0;
              text-align: initial;
            }          
          }
          .subscription-content {
            position: relative;
            .subscription-icon {
              display: inline-block;
              padding: 1rem;
              background: #C3E9CF;
              border-radius: 3rem;
              margin: 48px 0;
              i {
                border: 1px solid ${vars.colors.grey60};
                padding: 5px;
                border-radius: 3rem;
              }
              ${vars.breakpoints.sm} {
                display: none;
              }
            }
            .title {
              margin-bottom: 24px;
              ${vars.breakpoints.sm} {
                display: none;
              }
            }
            .split {
              display: none;
              ${vars.breakpoints.sm} {
                display: inline;
              }
            }
            .subtitle-details {
              display: block;
              padding-top: 16px;
              ${vars.breakpoints.sm} {
                display: inline;
              }
            }
          }
          .content-section {
            position: fixed;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            overflow: hidden;
            padding: 0 24px;
            ${vars.breakpoints.sm} {
              padding: 0 32px;
            }
            width: 100%;
            ${vars.breakpoints.sm} {
                position: static;
                transform: initial;
                width: initial;
            }
          }
          .title-content {
            display: flex;
            justify-content: flex-end;
            background: #FFF;
            padding: 32px 24px 0;
            ${vars.breakpoints.sm} {
              padding: 32px 32px 0;
            }
            z-index: 100;
            align-items: center;
            position: sticky;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
            .title {
              display: none;
              ${vars.breakpoints.sm} {
                display: block;
              }
            }
            ${vars.breakpoints.sm} {
                justify-content: space-between;
            }
          }
          .subtitle {
            ${vars.mixins.body1}
            span {
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .button-container {
            text-align: center;
            padding: 32px 0;
            background: #FFF;
            z-index: 100;
            align-items: center;
            position: sticky;
            bottom: 0;
            width: 100%;
            ${vars.breakpoints.sm} {
              text-align: right;
              padding: 16px 0;
            }
            & button {
             cursor: pointer;
            } 
            .submit-button {
              text-transform: uppercase;
              width: 180px;
              ${vars.breakpoints.sm} {
                margin-left: 16px;
              }
              .mantine-Button-icon {
                width: 16px;
              }
            }
          }
        `,
      },
      swapSubscriptionModalWrapper: `
        .mantine-Modal-content {
            position: fixed;
            top: 0;
            left: 0;
            min-width: 100vw;
            min-height: 100vh;
            ${vars.breakpoints.sm} {
                position: initial;
                min-width: min(90%, 828px);
                min-height: initial;
            }
        }
        .mantine-Modal-body {
          padding: 0;
          ${vars.breakpoints.sm} {
              padding: 0 32px;
          }
        }
        .case-description-mobile {        
          ${vars.mixins.body1}
          padding: 10px 16px 16px;
          ${vars.breakpoints.sm} {
            display: none;
          }
        }
        .title-content {
          padding-top: 24px;
          padding-bottom: 16px;
          padding-left: 16px;
          padding-right: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          ${vars.breakpoints.sm} {
            padding-top: 32px;
            padding-left: 0;
            padding-right: 0;
          }
        }
        .close-image {
          margin-bottom: 16px;
        }
        .button-container {
            .back-link {
              order: 2;
              min-width: 100%;
              ${vars.breakpoints.sm} {
                order: 1;
                min-width: 180px;
              }
              cursor: pointer;
              padding: 16px;
              
              text-align: center;
              & > div {
                ${vars.mixins.body1}
                border-bottom: 1px solid ${vars.colors.primary8};
                display: inline;
              }
            }
            display: flex;
            align-items: center;
            justify-content: end;
            flex-direction: column;
            gap: 8px;
            padding: 16px 24px;
            position: sticky;
            margin: 0;
            bottom: 0;
            left: 0;
            z-index: 2;
            background: white;
            box-shadow: 0px -5px 40px 0px #00141E1A;
            ${vars.breakpoints.sm} {
              flex-direction: row;
              gap: 24px;
              padding: 0 0 32px;
              position: static;
              box-shadow: none;
            }
            & button {
             cursor: pointer;
            }
            .submit-button {
              padding: 12px 24px;
              min-width: 100%;
              text-transform: uppercase;
              background: ${vars.colors.btnsPrimaryBg};
              order: 1;
              ${vars.breakpoints.sm} {
                order: 2;
                min-width: initial;
              }
              .mantine-Button-icon {
                width: 16px;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
              &:hover{
                 background-color: ${vars.colors.btnsPrimaryHoverBg};
              }
            }
          }
          .swap-subscription-error {  
            display: flex;
            align-items: center;
            gap: 8px;
            margin: 12px;
            background: ${vars.colors.primary7};
            padding: 12px;
            border-radius: 4px;
            font-size: ${vars.fonts.sizeSmall};
            font-weight: ${vars.fonts.weightMedium};
          }
      `,
      SwapSubscriptionModalPaymentDetailsWrapper: `
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        border-bottom: 1px solid ${vars.colors.secondary9};
        ${vars.breakpoints.sm} {
            gap: 12px;
        }
        h6.payment-details-title {
          margin-bottom: 0;
        }
        .payment-details-subtitle {
          ${vars.mixins.body1}
        }
        .payment-card {
          background: none;
          padding: 0;
          margin-bottom: 16px;
          ${vars.breakpoints.sm} {
            margin-bottom: 12px;
          }
        }
        .card-details-icon svg {
          width: 24px;
          height: 24px;
        }
      `,
      swapSubscriptionModalTermsWrapper: `
        padding-left: 16px;
        padding-right: 16px;
        ${vars.breakpoints.sm} {
          padding-left: 0;
          padding-right: 0;
        }
        padding-bottom: 16px;
        .terms-message {
          padding-bottom: 16px;
          ${vars.mixins.body1}
          ${vars.breakpoints.sm} {
            padding-bottom: 0;
          }
          span {
            font-weight: ${vars.fonts.weightBold};
          }
        }
        .terms-link {
          display: none;
          ${vars.breakpoints.sm} {
            display: block;
            padding: 16px 0;
          }        
          a {
            ${vars.mixins.body1}
            text-decoration: underline;
          }
        }
        .terms-link-mobile {
          ${vars.breakpoints.sm} {
            display: none;
          }
          padding: 16px 0;
          text-align: center;
          a {
            ${vars.mixins.body1}
            text-decoration: underline;
          }
        }
        .terms-personalize-message-text {
          ${vars.mixins.body1}
        }
        .terms-personalize-message {
          & > div {
            padding: 12px;
            background: #B3CFE5;
            color: #222;
            border-radius: 4px;
            span {
              display: flex;
              gap: 8px;
              i {
                padding-top: 2px;
              }
            }
          }
        }
      `,
      swapSubscriptionModalCaseDetailsWrapper: `
        padding-left: 16px;
        padding-right: 16px;
        ${vars.breakpoints.sm} {
           padding-left: 0;
           padding-right: 0;
        }
        .case-image{
          width: 150px;
          height: 150px;
          text-align: center;
          ${vars.breakpoints.sm} {
            width: 230px;
            height: 230px;
          }
          & img {
            width: auto;
            height: 100%;
          }
        }
        .case-option {
          display: flex;
          gap: 16px;
          padding-bottom: 16px;
          ${vars.breakpoints.sm} {
            gap: 24px;
          }
        }
        .case-information {
          padding-top: 8px;
          gap: 8px;
          display: flex;
          flex-direction: column;
          h6 {
            margin-bottom: 0;
          }
        }
        .case-description {
          display: none;
          ${vars.mixins.body1}
          ${vars.breakpoints.sm} {
            display: block;
          }
        }
        .case-fequency {
          ${vars.mixins.body1}
          ~ div {
            margin-bottom: 0;
          }
        }
        h6.base-price {
          ${vars.mixins.h8}
        }
      `,
    },
    flexModalWrapper: {
      wrapper: `
          .mantine-Modal-inner {
            z-index: 9999;
            .error{
              margin-top:16px;
              padding:18px;
              background-color:${vars.colors.errorLight};
              color:${vars.colors.error};
            }
          }
      
          .mantine-Modal-content {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            min-height: 100vh;
            border-radius: 0;
            & .mantine-Modal-body {
              padding: 0rem;
            }
          }
            
          .modal-content {
            position: relative;
            display: flex;
            flex-direction: column;
            padding: 0;
            ${vars.breakpoints.sm} {
              display: block;
              height: initial;
            }          
          }
          .sidebar {
            min-width: 200px;
            display: none;
            ${vars.breakpoints.lg} {
              display: block;
            }
            input[type="radio"] {
              display: none;
            }
            .user-filter-label {
              display: flex;
              gap: 8px;
              padding-bottom: 18px;
              ${vars.mixins.body1}
            }
          }
          .result {
            flex: 1;
            min-height: 70vh;
          }
          .hits-container {
            @media (min-width: 768px) and (max-width: 1229px) {
              margin-bottom: 100px;
            }
          }
          .content {        
            display: flex;
            min-height: 100vh;
            gap: 24px;
            .loading-indicator {
              margin-top: 1rem;
            }
            ${vars.breakpoints.sm} {
              padding: 0 32px;
            }
            ${vars.breakpoints.xxl} {
              padding: 0 120px;
            }
          }
          .search-content {
            ${vars.breakpoints.sm} {
              padding: 0 24px;
            }
          }
          .title-container {
            flex: 1;
            text-align: center;
            .title {
              margin-bottom: 8px;
              text-align: left;
              font-size: ${vars.fonts.sizeH2};
              ${vars.breakpoints.sm} {
                text-align: center;
              }
            }
            .sub-title {
              ${vars.mixins.body2}
              text-align: left;
              margin-top: 16px;
              ${vars.breakpoints.sm} {
                ${vars.mixins.body1}
                text-align: center;
                margin-top: 0;
              }
            }
           }
          .title-content {
            display: flex;
            justify-content: space-between;
            background: #FFF;
            padding: 16px;
            z-index: 100;
            align-items: baseline;
            position: sticky;
            top: 0;
            width: 100%;
            box-shadow: 0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05),rgba(0, 0, 0, 0.05) 0 0.625rem 0.9375rem -0.3125rem,rgba(0, 0, 0, 0.04) 0 0.4375rem 0.4375rem -0.3125rem;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
            ${vars.breakpoints.sm} {
              padding: 32px 64px;
              align-items: center;
            }
          } 
          .ais-Hits-item{
            box-shadow: none;
            padding: 1.5rem 0;
            height: 100%;
            justify-content: center;
            ${vars.breakpoints.lg} {
              justify-content: start;
            }
          } 
          div.clear-refinements-container {
              button {
                border: none;
              }
           }
          .ais-Hits-list {
            gap: 12px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: baseline;
            ${vars.breakpoints.sm} {
              gap: 24px;
            }
            ${vars.breakpoints.md} {
              grid-template-columns: 1fr 1fr;
            }
            ${vars.breakpoints.lg} {
              grid-template-columns: 1fr 1fr 1fr;
            }
            ${vars.breakpoints.xl} {
              grid-template-columns: 1fr 1fr 1fr;
            }
            ${vars.breakpoints.xxl} {
              grid-template-columns: 1fr 1fr 1fr 1fr;
            }
          }  
          .search {
            .search-sort-box {
              display: flex;
              justify-content: space-between;
              gap: 8px;
              padding: 0 16px;
              ${vars.breakpoints.sm} {
                gap: 16px;
                padding: 0;
              }          
            }
            .toolbar-start {
                display: none;
                ${vars.breakpoints.lg} {
                  display: block;
                }
            }
            .mobile-filter-block {
              display: flex;
              order: 2;
              ${vars.breakpoints.sm} {
                order: 1;
                flex: 1; 
              }
              ${vars.breakpoints.lg} {
                display: none;
              }
              .mobile-filter-box {
                cursor: pointer;
                flex: 1;
                background-color: initial;
                border: 1px solid ${vars.colors.primary8};
                border-radius: 4px 0 0 4px;
                padding: 9px 12px;
                height: 40px;
                ${vars.breakpoints.sm} {
                  border-radius: 5px 0 0 5px;
                  padding: 1px 6px;
                  height: initial;
                }
                span {
                  display: none;
                  ${vars.breakpoints.sm} {
                    display: inline;
                  }
                }
                .applied-filter-red-dot-icon {
                  display: inline-block;
                  width: 9px;
                  height: 9px;
                  background-color: #D7363B;
                  border-radius: 50%;
                  position: relative;
                  left: 25px;
                  bottom: 10px;
                  border: 1.5px solid #FFFFFF;
                  ${vars.breakpoints.sm} {
                    left: 40px;
                  }
                }
              }
              .mobile-sort-box {
                flex: 1;
                .mobile-sorting-wrapper {
                  .action-trigger {
                        width: 100%;
                        background-color: initial;
                        border: 1px solid ${vars.colors.primary8};
                        border-radius: 0 5px 5px 0;
                        border-left: 0;
                        padding: 9px 12px;
                        height: 40px;
                  }
                }
                .results {
                  .options {
                    border-radius: 0 5px 5px 0;
                    border-left-width: 0;
                  }
                  .label {
                    display: none;
                    ${vars.breakpoints.lg} {
                      display: block;
                    }
                  }
                }
              }
            }
            .search-box-wrapper {
               display: flex; 
               gap: 16px;
               flex: 1;
               order: 1;
              ${vars.breakpoints.sm} {
                order: 2;
              }
               ${vars.breakpoints.lg} {
                justify-content: flex-end;
               }
               .ais-SearchBox {
                 flex: 1;
                 ${vars.breakpoints.lg} {
                  flex: initial;
                 }
               }
               .desktop-sort-box{
                display: none;
                ${vars.breakpoints.lg} {
                  display: block;
               }
             }
            .toolbar-start {
                flex: 1;
                align-self: center;
                display: none;
                ${vars.breakpoints.lg} {
                  display: block;
                }
                .clear-refinements {
                  border: none;
                }
            }
            .ais-SearchBox-input {
              border: 1px solid ${vars.colors.primary8};
              border-radius: 4px;
              height: 40px;
              padding: 4px 12px;
              box-shadow: none;
              ${vars.breakpoints.sm} {
                width: 240px;
                padding: 11px 16px;
              }
            }
            .ais-SearchBox-form::before {
              left: initial;
              right: 4px;
              left: initial;
            }
          }      
        `,
    },
    mobileFilterModal: {
      wrapper: `
        input[type="radio"] {
              display: none;
        }
        div.clear-refinements-container {
           display: flex;
           button {
             border: none;
            }
        }
        .user-filter-label {
          display: flex;
          gap: 8px;
          padding-bottom: 18px;
          ${vars.mixins.body1}
        }
        .mantine-Modal-inner {
          align-items: flex-start;
          justify-content: flex-start;
          padding: 0;
          z-index: 9999;
         }
        .mantine-Modal-content {
          min-height: 100vh;
          min-width: 100vw;
          ${vars.breakpoints.sm} {
            min-width: initial;
          }
        }
        .mantine-Modal-overlay {
          z-index: 9999;
        }
        .mantine-Modal-body {
          padding: 32px 16px 16px;
        }
        .button-container {
          position: sticky;
          bottom: 0px;
          background: white;
          padding: 16px 0;
          display: flex;
          gap: 10px;
          button {
              width: 100%;  
              padding: 12px 16px; 
              text-transform: uppercase;
              ${vars.mixins.body2}
              font-weight: ${vars.fonts.weightMediumPlus};
              line-height: 16px;
           }
        }
        .title-content {
            display: flex;
            justify-content: space-between;
            background: #FFF;
            align-items: center;
            position: sticky;
            z-index: 100;
            top: 0;
            width: 100%;
            & i {
              margin-bottom: 16px;
              cursor: pointer;
            }
          }
      `,
    },
    flexFooterModalWrapper: {
      wrapper: `
        position: sticky;
        bottom: 0;
        left: 0;
        min-height: 196px;
        background: #FFF;
        padding: 24px 32px;
        box-shadow: 0px -5px 40px 0px rgba(0, 20, 30, 0.1), 0px 10px 20px 0px rgba(0, 20, 30, 0.2);
        gap: 20px;
        justify-content: space-between;
        display: none;
        ${vars.breakpoints.lg} {
          display: flex;
        }
        ${vars.breakpoints.xxl} {
          padding: 24px 100px;
        }
        .mantine-Carousel-controls {
          padding-left: 0;
          padding-right: 0;
        }
        .mantine-Carousel-indicator {
          bottom: 0;
        }
        .save-changes-section {
          min-width: 260px;
          display: flex;
          gap: 12px;
          flex-direction: column;
          .error-message {
            max-width: 260px;
          }
          .tablet-count-error-message {
            display: none;
            ${vars.breakpoints.md} {
             display: block;
            }
            ${vars.breakpoints.lg} {
             display: none;
            }
          }
          .desktop-count-error-message {
            display: none;
            ${vars.breakpoints.lg} {
             display: block;
            }
          }
        }
        .flex-products {
          flex: 1;
          position: relative;
          overflow: hidden;
          ${vars.breakpoints.lg} {
            padding: 0 42px;
            .mantine-Carousel-slide {
              display: flex;
              justify-content: center;
            }
          }
          .image-bg {
           position: relative;
          }
        }
        .product-hover {
          position: absolute;
          top: 0;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .flex-product-skeleton {
          width: 108px;
          min-height: 148px;
          .product-title {
            margin-top: 8px;
            ${vars.mixins.body3}
            color: ${vars.colors.secondary12};
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-align: center;
            
          }
          .image-container {
            position: relative;
            width: 108px;
            height: 108px;
            padding: 6px;
            margin: auto;
          }
        }
        .flex-product{
          width: 108px;
          min-height: 148px;
          &.product-hover {
            .image-container {
              filter: opacity(0.2);
            }
            .product-title {
              display: none;
            }
          }
          .image-bg {
           position: relative;
          }
          .product-quantity {
             display: flex;
             gap: 10px;
             align-items: center;
             ${vars.mixins.body1}
             .btn {
                  padding: 12px;
                  line-height: 0;
                  border-radius: 100px;
             }
           }
          .product-full-title {     
            ${vars.mixins.body3}
            flex: 1;
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: center;
          }
          .image-container {
            position: relative;
            width: 108px;
            height: 108px;
            padding: 6px;
          }
          .count {
            position: absolute;
            right: 0;
            top: 2px;
            ${vars.mixins.body3}
            font-weight: ${vars.fonts.weightMediumPlus};
            padding: 2px 6px;
            background: ${vars.colors.unlimitedButtonColor};
            color: #fff;
            border-radius: 10px;
          }
          .product-title {
            margin-top: 8px;
            ${vars.mixins.body3}
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            text-align: center;
            overflow: hidden;
          }
        }
        .price-section {
          display: flex;
          gap: 4px;
          flex-direction: column;
        }
        .bottle-price {
          display: flex;
          gap: 16px;
          align-items: baseline;
          .discount {
            ${vars.mixins.body2}
            color: ${vars.colors.btnsTertiaryBg};
            font-weight: ${vars.fonts.weightBold};
          }
          .price {
            margin-bottom: 0;
          }
        }
        .bottle-count {
          ${vars.mixins.body1}
          color: ${vars.colors.secondary15};
        }
        .submit-button {
              width: 100%;  
              padding: 16px; 
              text-transform: uppercase;
              ${vars.mixins.body2}
              font-weight: ${vars.fonts.weightMediumPlus};
              line-height: 16px;
              background: ${vars.colors.btnsPrimaryBg};
              .mantine-Button-icon {
                width: 16px;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
              &:focus,&:hover {
                background-color: ${vars.colors.btnsPrimaryHoverBg};
                color: ${vars.colors.btnsPrimaryHoverColor};
              }
        }
      `,
    },
    flexMobileFooterModalWrapper: {
      wrapper: `
        position: sticky;
        bottom: 0;
        left: 0;
        background: #FFF;
        padding: 12px 16px;
        box-shadow: 0px -5px 40px 0px rgba(0, 20, 30, 0.1), 0px 10px 20px 0px rgba(0, 20, 30, 0.2);
        gap: 16px;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        ${vars.breakpoints.lg} {
          flex-direction: row;
        }
        ${vars.breakpoints.lg} {
          padding: 12px 32px;
        }
        ${vars.breakpoints.lg} {
          display: none;
        }
        .bottle-count {
          display: none;
        }
        .save-changes-button-container {
            display: flex;
            flex-direction: column;
          }
        .save-changes-section {
          min-width: 260px;
          display: flex;
          gap: 12px;
          flex-direction: row;
          align-items: center;
          flex: 1;
          justify-content: space-between;
          .tablet-count-error-message{
            display: none;
            ${vars.breakpoints.sm} {
             padding-bottom: 12px;
             display: block; 
            }
          }
          .desktop-count-error-message {
            display: none;
          }
          .error-message {
            max-width: 260px;
          }
        }
        .bottle-price {
          display: flex;
          align-items: baseline;
          flex-direction: column;
          gap: 8px;
          ${vars.breakpoints.sm} {
             gap: 12px;
             flex-direction: row;
          }
          .discount {
            ${vars.mixins.body2}
            color: ${vars.colors.btnsTertiaryBg};
            font-weight: ${vars.fonts.weightMediumPlus};
            font-size: 12px;
            ${vars.breakpoints.sm} {
              font-size: 14px;
              font-weight: ${vars.fonts.weightBold};
            }
          }
          .price {
            margin-bottom: 0;
          }
        }
        .submit-button {
              padding: 12px 24px;
              text-transform: uppercase;
              ${vars.mixins.body2}
              font-weight: ${vars.fonts.weightMediumPlus};
              line-height: 16px;
              background: ${vars.colors.btnsPrimaryBg};
              .mantine-Button-icon {
                width: 16px;
              }
              &:disabled{
                 background-color: ${vars.colors.grey00};
                 color: ${vars.colors.grey70};
              }
              &:focus,&:hover {
                background-color: ${vars.colors.btnsPrimaryHoverBg};
                color: ${vars.colors.btnsPrimaryHoverColor};
              }
        }
      `,
    },
    floatingCartWrapper: {
      wrapper: `
        position: absolute;
        bottom: 100px;
        left: 0;
        background: #fff;
        width: 344px;
        padding: 0 16px 12px 32px;
        box-shadow: 0px -5px 40px 0px #00141E1A;
        box-shadow: 0px 10px 20px 0px #00141E33;
        max-height: 200px;
        transition: max-height 0.4s ease;
        overflow: scroll;
        display: none;
        ${vars.breakpoints.sm} {
          display: block;
        }
        &.expanded {
          max-height: calc(100vh - 250px);
        }
        .bottle-cart-count {
          ${vars.mixins.body1}
          color: ${vars.colors.secondary15};
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          position: sticky;
          top: 0px;
          background: white;
          padding: 12px 0;
          cursor: pointer;
          z-index: 200;
        }
        .image {
          width: 40px;
          height: 48px;
          position: relative;
        }
        .flex-items {
          display: flex;
          justify-content: space-between;
        }
        .image {
          width: 40px;
          height: 48px;
          position: relative;
        }
        .more-items {
          background-image: url(/next/images/default_images/bottle_empty.png);
          width: 40px;
          height: 48px;
          background-size: cover;
          display: flex;
          align-items: center;
          justify-content: center;
          background-position: center;
        }
      `,
    },
    mobileFloatingCartWrapper: {
      wrapper: `
        .mantine-Modal-inner {
          z-index: 9999;
          height: 80%;
          pointer-events: none;
          background-color: rgba(0, 0, 0, 0.2);
          padding-bottom: 2dvh;
        }
        section.mantine-Paper-root {
          min-width: 100vw;
          height:calc(100vh - 166px);
          box-shadow: none;
        }
        .mantine-Modal-body {
          padding: 0px 16px;
        }
        .mantine-Modal-header {
          padding: 0;
        }
        .mantine-Modal-content {
          margin-top: 17vh;
          margin-bottom: 46px;
          ${vars.breakpoints.sm}{
            margin-top: 0;
          }
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0px;
          background: white;
          padding: 10px 16px;
          cursor: pointer;
          z-index: 200;
          .header-text {
            margin-bottom: 0;
          }
        }
        .image {
          width: 40px;
          height: 48px;
          position: relative;
        }
        .flex-items {
          display: flex;
          justify-content: space-between;
        }
        .image {
          width: 40px;
          height: 48px;
          position: relative;
        }
      `,
    },
    floatingCartExpandedProductWrapper: {
      wrapper: `
        display: flex;
        gap: 12px;
        padding: 12px 0;
        border-bottom: 1px solid ${vars.colors.secondary9};
        :last-child {
           border:none;
         }
        ${vars.breakpoints.sm}
        {
          :last-child {
           border: default;
        }
        }
        .image-container {
          width: 84px;
          height: 84px;
          position: relative;
          ${vars.breakpoints.sm} {
            width: 96px;
            height: 96px;
          }
        }
        .count {
            position: absolute;
            right: 0;
            top: 2px;
            ${vars.mixins.body3}
            font-weight: ${vars.fonts.weightMediumPlus};
            padding: 2px 6px;
            background: ${vars.colors.unlimitedButtonColor};
            color: #fff;
            border-radius: 10px;
        }
        .image-bg {
          position: relative;
        }
        .product-details {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .cart-count {
          ${vars.mixins.body1}
          padding: 0 10px;
        }
        .product-quantity {
          display: flex;
          align-items: center;
          gap: 8px;
          button {
            border-radius: 16px;
            padding: 0;
            width: 32px;
            height: 32px;
            border-color: ${vars.colors.secondary9}
          }
          button:focus {
              padding: 0;
              border-color: ${vars.colors.secondary9};
              border-width: 1px;
          }
          i {
            font-size: 16px;
          }
        }
      `,
    },
    flexMobileFooterWrapper: {
      wrapper: `
        display: flex;
        z-index: 1;
        justify-content: space-between;
        ${vars.breakpoints.sm} {
          display: none;
        }
        .mobile-summary-section {
          display: flex;
          gap: 8px;
          align-items: center;
        }
        .mobile-bottle-count {
          ${vars.mixins.body2}
          color: ${vars.colors.secondary15};
        }
        .mini-bottle-count {
          ${vars.mixins.body2}
          color: #AA182B;
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .view-all {
          ${vars.mixins.body2}
          color: ${vars.colors.secondary15};
          display: flex;
          align-items: center;
          gap: 4px;
        }
      `,
    },
    flexMinimumCountWrapper: {
      wrapper: `
        &.mini-bottle-count {
          ${vars.mixins.body2}
          color: #AA182B;
          display: flex;
          align-items: center;
          gap: 4px;
        }
      `,
    },
    confirmCloseConfirmationModalWrapper: {
      wrapper: `
        .mantine-Modal-inner {
          z-index: 9999;
          background-color: rgba(0, 0, 0, 0.2);
        }
        .mantine-Modal-content {
          min-width: 700px;
          box-shadow: 0px 30px 60px 0px #341F001A;
          border-radius: 16px;
        }
        .title-content {
          display: flex;
          justify-content: space-between;
          margin-top: 32px;
          align-items: center;
        }
        .close-content {
          margin-bottom: 16px;
        }
        .mantine-Modal-body {
          padding: 0 32px;
        }
        .changes-content {
          ${vars.mixins.body1}
        }
        .content-section {
          display: flex;
          flex-direction: column;
          gap: 32px;
        }
        button.cancel-button {
           border: 1px solid ${vars.colors.black};
           font-weight: 600;
           &:hover {
             background: inherit;
             color: inherit;
           }
        }
        .button-container {
             display: flex;
              gap: 24px;
              justify-content: flex-end;
              padding-bottom: 32px;
          }
        .submit-button:focus {
          background-color: ${vars.colors.secondary6};
          color: #FFF;   
        }
      `,
    },
    confirmCloseConfirmationMobileWrapper: {
      wrapper: `
         .title-content {
           display: flex;
           justify-content: space-between;
           align-items: center;
         }
         .changes-content {
           ${vars.mixins.body1}
           text-align: left;
         }
         .button-container {
           position: absolute;
           bottom: 16px;
           display: flex;
           flex-direction: column;
           gap: 8px;
           width: calc(100% - 40px);
           & button {
             font-weight: ${vars.fonts.weightMediumPlus};
           }
           .submit-button:focus {
              background-color: ${vars.colors.secondary6};
              color: #FFF;   
           }
         }
         .close-content {
           margin-bottom: 16px;
         }
         .mantine-Modal-inner  {
            z-index: 9999;
         }
         section.mantine-Paper-root {
           border-top-left-radius: 12px;
           border-top-right-radius: 12px;
           padding: 24px;
         }
         .mantine-Modal-overlay {
            z-index: 9999;
          }
        .mantine-Modal-content {                
            min-width: 70%;
            position: fixed;
            top: 150px;
            left: 0;
            width: 100%;
            height: calc(100vh - 150px);
            & .mantine-Modal-body {
              padding: 0rem;
            }
          }
          .modal-content {
            text-align: center;          
          }
      `,
    },
    fetchProductLoaderModalWrapper: {
      wrapper: `
        .mantine-Modal-inner {
          z-index: 9999;
        }
        .mantine-Modal-content {
          flex: initial;
          box-shadow: none;
        }
        svg {
          stroke: ${vars.colors.btnsTertiaryBg};
        }
      `,
    },
    selectedRadio: `
       ${vars.icons['radio-selected']}
        :before {
          ${vars.mixins.iconBase}
         line-height:0;
         font-size:18px;
         font-weight:${vars.fonts.weightBold} !important;
         color:${vars.colors.secondary6};
         
       }
       `,
    unselectedRadio: `
       ${vars.icons['radio']}
        :before {
          ${vars.mixins.iconBase}
         line-height:0;
         font-size:18px;
         font-weight:${vars.fonts.weightBold} !important;
         color:transparent;
         -webkit-text-stroke: 0.5px ${vars.colors.secondary7};
         text-stroke: 0.5px ${vars.colors.secondary7};
       }`,
    productHitWrapper: {
      wrapper: `
        &.hit-product {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .image-bg {
          background: ${vars.colors.primary3};
        }
        .image-container {
          width: 100%;
          height: 290px;
          position: relative;
        }
        .image img {
          padding: 16px;
        }
        .hit-content {
          display: flex;
          flex-direction: column;
          gap: 8px;
          flex: 1;
          padding: 8px 16px 0;
          ${vars.breakpoints.sm} {
            padding: 0;
            gap: 24px;
          }
        }
        .title, .image-bg {
          cursor: pointer;
        }
        .case-update {
          ${vars.mixins.body3}
          font-weight: ${vars.fonts.weightMediumPlus};
          color:#006E1A;
          background:  ${vars.colors.secondary16};
          padding: 4px;
          border-radius: 12px;
          width: max-content;
          display: flex;
          gap: 8px;
          align-items: center;
          position: absolute;
          top: 1rem;
          left: 0.5rem;
          ${vars.breakpoints.sm} {
            padding: 4px 12px;
          }
          span {
            display: none;
            ${vars.breakpoints.sm} {
              display: inline;
            }
          }
        }
        .title-container {
          padding-top: 0;
          display: flex;
          flex-direction: column;
          gap: 4px;
          ${vars.breakpoints.sm} {
            padding-top: 12px;
          }
          .title {
            ${vars.mixins.body1}
            text-align: left;
          }
          .product-description {
            ${vars.mixins.body2}
            color: ${vars.colors.secondary15};
          }
          .product-description-content {
            gap: 6px;
            align-items: center;
            flex-flow: wrap;
            display: none;
            ${vars.breakpoints.sm} {
              display: flex;
            }
            span.seperator {
              width: 4px;
              height: 4px;
              background: ${vars.colors.secondary9};
              border-radius: 4px;
            }
          }
        }
        .info-container {
          display: flex;
          flex-direction: column;
          gap: 12px;
          .rating {
            display: flex;
            gap: 4px;
            align-items: center;
          }
          .reviews {
            ${vars.mixins.body1}
            position: relative;
            top: -2px;
          }
          .addToCase-container button{
            cursor: pointer;
            text-decoration: none;
            padding: 7px 16px;
            text-transform: uppercase;
            border: 1px solid ${vars.colors.primary8};
            border-radius: 4px;
            ${vars.mixins.body1}
            font-weight: ${vars.fonts.weightMediumPlus};
            font-size: ${vars.fonts.sizeSmall};
            line-height: 14px;
            text-align:center;
            color: initial;
            &:hover {
              background-color: ${vars.colors.btnsPrimaryHoverBg};
              color: ${vars.colors.btnsPrimaryHoverColor};
            }
            ${vars.breakpoints.sm} {
              font-size: ${vars.fonts.fontSize16};
              line-height: 16px;
              padding: 12px 24px;
            }
          }
          .product-quantity {
            display: flex;
            align-items: center;
            gap: 8px;
            .cart-count {
              ${vars.mixins.body1}
              padding: 0 4px;
            }
            button {
              border-radius: 16px;
              padding: 0;
              width: 32px;
              height: 32px;
              border-color: ${vars.colors.secondary9}
            }
            button:focus {
                padding: 0;
                border-color: ${vars.colors.secondary9};
                border-width: 1px;
            }
            button:hover {
                background-color: #fff;
                color: initial;
            }
            i {
              font-size: 16px;
            }
          }
        }
        .price-container {
          display: flex;
          gap: 4px;
          flex-direction: column;
          ${vars.mixins.body2}
          ${vars.breakpoints.sm} {
            flex-direction: row;
          }
          .price-value-text {
            display: flex;
            gap: 4px;
          }
          .price-value-discounted {
            font-weight: ${vars.fonts.weightBold};
          }
          .price-value-actual-strike {
            text-decoration: line-through;
           }
        }
    `,
    },
  },
});
